var _defs, _style, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g8, _path17, _path18, _path19, _path20, _path21, _path22, _g9, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g10, _g11, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g12, _path57, _path58, _path59, _g13, _path60, _path61, _g14, _path62, _path63, _g15, _path64, _g16, _g17, _g18, _g19, _path65, _g20, _path66, _path67, _g21, _path68, _path69, _path70, _g22, _path71, _g23, _path72, _g24, _g25, _path73, _g26, _path74, _g27, _path75, _path76, _path77, _path78, _path79, _g28, _g29, _g30, _path80, _path81, _path82, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path83, _g38, _path84, _g39, _g40, _path85, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _path86, _g52, _g53, _g54, _g55, _path87, _g56, _g57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1684 1120",
    width: 1684,
    height: 1120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img2-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1354.17 576.5c10.79 32.63-5.59 71.32-34.51 60.87-28.92-10.44-50.25-63.52-53.08-93.8q-0.21-2.35-0.3-4.53-0.04-0.91-0.07-1.77-0.01-1.02-0.01-2-0.08-23.94 10.06-32.77c15.08-8.9 67.1 41.36 77.91 74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1380.98 930.78q-62.92 0-72.41-22.21l-20.78-146.97h177.47l-20.76 146.97q-0.6 22.21-63.52 22.21z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1412.32 651.22q22.36-16.61 46.92-10.99c24.56 5.6 55.71 40.42 55.71 69.43q-33.59-53.63-103.35-58.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1332.08 352.83c25.68 20.4 58.35 54.42 61.32 83.61 5.16 28.61-8.41 54.52-22.3 65.82-14.64 12.01-29.6 9.41-44.35-2.59-29.47-24.27-41.37-74.72-44.03-110.44q-0.18-2.73-0.31-5.3-0.06-1.07-0.12-2.11-0.04-1.21-0.08-2.4c-1.03-28.84 1.1-46.64 1.36-46.44 1.99-8.67 21.76-1.22 48.51 19.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1332.08 352.83c25.68 20.4 58.35 54.42 61.32 83.61 5.16 28.61-8.41 54.52-22.3 65.82-14.64 12.01-29.6 9.41-44.35-2.59-29.47-24.27-41.37-74.72-44.03-110.44q-0.18-2.73-0.31-5.3-0.06-1.07-0.12-2.11-0.04-1.21-0.08-2.4c-1.03-28.84 1.1-46.64 1.36-46.44 1.99-8.67 21.76-1.22 48.51 19.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1332.08 352.83c25.68 20.4 58.35 54.42 61.32 83.61 5.16 28.61-8.41 54.52-22.3 65.82-14.64 12.01-29.6 9.41-44.35-2.59-29.47-24.27-41.37-74.72-44.03-110.44q-0.18-2.73-0.31-5.3-0.06-1.07-0.12-2.11-0.04-1.21-0.08-2.4c-1.03-28.84 1.1-46.64 1.36-46.44 1.99-8.67 21.76-1.22 48.51 19.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1317.16 515.43c24.08 26.51 18.78 79.11-14.71 88.87-34.46 11.7-78.48-20.64-95.87-40.7q-1.32-1.61-2.45-3.13-0.47-0.63-0.91-1.23-0.5-0.73-0.96-1.43c-11.61-16.67-6.01-28.69-5.93-29.09 9.66-19.55 96.35-43.21 120.83-13.29z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1317.16 515.43c24.08 26.51 18.78 79.11-14.71 88.87-34.46 11.7-78.48-20.64-95.87-40.7q-1.32-1.61-2.45-3.13-0.47-0.63-0.91-1.23-0.5-0.73-0.96-1.43c-11.61-16.67-6.01-28.69-5.93-29.09 9.66-19.55 96.35-43.21 120.83-13.29z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1317.16 515.43c24.08 26.51 18.78 79.11-14.71 88.87-34.46 11.7-78.48-20.64-95.87-40.7q-1.32-1.61-2.45-3.13-0.47-0.63-0.91-1.23-0.5-0.73-0.96-1.43c-11.61-16.67-6.01-28.69-5.93-29.09 9.66-19.55 96.35-43.21 120.83-13.29z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1410.17 462.2q32.63-71.79 30.67-100.12c-1.96-28.34 18.93-45.2 41.12-40.48 22.19 4.72 24.64 67.41-3.91 102.53-28.55 35.13-45.04 39.04-67.88 38.07z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1281.28 496.94c-23.56-28.98-21.55-80.71-3.23-84.6 18.31-3.91 35.54 10.01 33.93 33.4q-1.61 23.37 25.32 82.62c-18.85 0.8-32.46-2.43-56.02-31.42z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1514.9 560.4q52.64 9.93 54.47 36.8c-52.39-26.59-148.85 25.12-155.98 25.4q-7.12 0.28 1.89-15.58c11.65-19.58 46.96-56.56 99.62-46.62z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1203.13 634.14q3.37-3.65 2.47-10.61c-0.9-6.95-5.63-26.45 31.2-21.72 36.83 4.74 72.79 23 84.7 35.06 11.92 12.06 15.9 14.99 18.03 15.8 2.12 0.82 24.21 0.96 24.44 8.23 0.23 7.26-21.85 20.54-39.2 15.82-17.34-4.73-69.04-22.3-82.9-32.21-13.85-9.92-32.56-15.09-38.74-10.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1394.46 703.52q30.92-19.74 62.4-26.92c31.49-7.18 44.08-5.6 44.08 10 0 15.59-13.17 21.41-11.16 27.49q2.01 6.08 6.87 8.56-6.3-4.86-15.17 1.49c-8.88 6.35-25.31 18.25-66.7 18.61-41.38 0.34-41.79-2.22-50.38-13.33q-8.59-11.1-8.29-31.98 22.04 0.79 38.35 6.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1309.42 691.7q5.48-19.62 36.07-26.27 30.6-6.63 51.77 1.5 7.13 32.66-13.05 50.4c-20.18 17.74-33.8 10.86-57.27 6.64-23.48-4.22-33.43 15.47-45.43 6.24-12.01-9.26-4.13-40.8 27.91-38.51z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1383.98 734.8c5.83-1.18 21.58-0.32 18.45 12.2-3.13 12.51-45.98 46.91-56.84 47.85q-10.85 0.93-10.4 10.31-1.56-3.43-4.17-7.81c-2.61-4.38-9.59-7.2-20.85-20.71-11.26-13.51-20.95-42.78 4.06-46.89q25.02-4.12 43.42 17.23 20.5-11 26.33-12.18z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1450.47 557.86c-8.55 12.5-24.1-3.13-45.12 8.15-21.01 11.27-31.83 22.03-56.51 11.41q-24.68-10.62-28.01-43.88 17.6-14.29 48.76-17.45 31.14-3.16 42.43 13.81c29.74-12.1 47.01 15.45 38.45 27.96z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #fbfaff } \n\t\t.s1 { fill: #3789f2 } \n\t\t.s2 { fill: #102553 } \n\t\t.s3 { fill: #ffffff } \n\t\t.s4 { fill: #fffeff } \n\t\t.s5 { fill: #20b723 } \n\t\t.s6 { fill: #21312d } \n\t\t.s7 { fill: #e2cb23 } \n\t\t.s8 { fill: #231f20 } \n\t\t.s9 { fill: #7ab6c4 } \n\t\t.s10 { fill: #82c1d0 } \n\t\t.s11 { fill: #50a9bf } \n\t\t.s12 { fill: #5caec2 } \n\t\t.s13 { fill: #81bfce } \n\t\t.s14 { fill: #9ec9d3 } \n\t\t.s15 { fill: #4fa6bc } \n\t\t.s16 { fill: #09214c } \n\t\t.s17 { fill: #21a323 } \n\t\t.s18 { fill: #6a3f2e } \n\t\t.s19 { mix-blend-mode: multiply;fill: #6a3f2e } \n\t\t.s20 { fill: #3e2210 } \n\t\t.s21 { fill: #041733 } \n\t\t.s22 { opacity: .4;mix-blend-mode: multiply;fill: #1745ba } \n\t\t.s23 { fill: #7298f7 } \n\t\t.s24 { fill: #395915 } \n\t\t.s25 { mix-blend-mode: multiply;fill: #ceb313 } \n\t\t.s26 { fill: #9cb240 } \n\t\t.s27 { mix-blend-mode: multiply;fill: #1745ba } \n\t\t.s28 { fill: #3f68ea } \n\t\t.s29 { mix-blend-mode: overlay;fill: #21a323 } \n\t\t.s30 { mix-blend-mode: overlay;fill: #5b80d3 } \n\t\t.s31 { fill: #694e1b;stroke: #947637;stroke-width: 3.7 } \n\t\t.s32 { fill: #656d34 } \n\t\t.s33 { fill: #946652 } \n\t\t.s34 { fill: #947637 } \n\t\t.s35 { fill: #d4cc71 } \n\t\t.s36 { fill: #36201b } \n\t\t.s37 { fill: #052a7a } \n\t\t.s38 { opacity: .3;mix-blend-mode: multiply;fill: #38502b } \n\t\t.s39 { mix-blend-mode: overlay;fill: #7194ea } \n\t\t.s40 { fill: #ceb313 } \n\t\t.s41 { fill: #99bbff } \n\t\t.s42 { fill: #2057d1 } \n\t\t.s43 { opacity: .1;mix-blend-mode: multiply;fill: #1745ba } \n\t\t.s44 { fill: #225ad6 } \n\t\t.s45 { fill: #6490ff } \n\t\t.s46 { opacity: .4;mix-blend-mode: multiply;fill: #6490ff } \n\t\t.s47 { mix-blend-mode: overlay;fill: #6490ff } \n\t\t.s48 { fill: #fe5e7d } \n\t\t.s49 { mix-blend-mode: multiply;fill: #968488 } \n\t\t.s50 { fill: #030000 } \n\t\t.s51 { fill: #15002b } \n\t\t.s52 { fill: #fdf1e0 } \n\t\t.s53 { fill: #000000 } \n\t\t.s54 { fill: #0d1f71 } \n\t\t.s55 { fill: #2f0364 } \n\t\t.s56 { fill: #e0e6fe } \n\t\t.s57 { fill: #d1d3d4 } \n\t\t.s58 { fill: #ed8c8c } \n\t\t.s59 { fill: #f7941e } \n\t\t.s60 { fill: #d5e1fd } \n\t\t.s61 { fill: #ff9e9e } \n\t\t.s62 { fill: #ffa1a1 } \n\t\t.s63 { fill: #352893 } \n\t\t.s64 { fill: #5731f7 } \n\t\t.s65 { mix-blend-mode: multiply;fill: #5731f7 } \n\t\t.s66 { fill: #260654 } \n\t\t.s67 { fill: #24005e } \n\t\t.s68 { fill: #23054f } \n\t\t.s69 { fill: #27aae1 } \n\t\t.s70 { fill: #7fe6b1 } \n\t\t.s71 { fill: #2e0461 } \n\t\t.s72 { fill: #ef8484 } \n\t\t.s73 { fill: #fcfdfd } \n\t\t.s74 { fill: #fdfcf2 } \n\t\t.s75 { fill: #91a0b8 } \n\t\t.s76 { fill: #e9efd2 } \n\t\t.s77 { fill: #ee9d87 } \n\t\t.s78 { fill: #3f3e3d } \n\t\t.s79 { fill: #e0d3c7 } \n\t\t.s80 { fill: #f7bcaa } \n\t\t.s81 { fill: #82b2fc } \n\t\t.s82 { fill: #544231 } \n\t\t.s83 { fill: #d7b69f } \n\t\t.s84 { fill: #b07dd7 } \n\t\t.s85 { fill: #458290 } \n\t\t.s86 { opacity: .2;fill: #192326 } \n\t\t.s87 { fill: #f9f6f4 } \n\t\t.s88 { fill: #4c4b4a } \n\t\t.s89 { fill: #232121 } \n\t\t.s90 { fill: #e2923b } \n\t\t.s91 { fill: #0d4444 } \n\t\t.s92 { fill: #fcaa48 } \n\t\t.s93 { fill: #1068b2 } \n\t\t.s94 { fill: #2e2c70 } \n\t\t.s95 { fill: #929d47 } \n\t\t.s96 { fill: #bac161 } \n\t\t.s97 { fill: #ffe088 } \n\t\t.s98 { mix-blend-mode: multiply;fill: #ffe088 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1683.8 1128h-1683.8v-1190.6h1683.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m217.6 295q67.8 18.1 95.1 80.5c27.3 62.3 15.8 106.7 6.6 121.4-9.3 14.8-11.8 63.9-1.4 91.6q-11.8-37-11.1-91.6c0.7-54.6-20.9-54.6-33.1-95.2-12.3-40.6-32.2-77.9-33.3-79.4q-1.2-1.5-17-19.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m332.7 441.5c-11-13.3-39.8-43.7-44.1-80.3q-4.2-36.5-31.2-88 111.9 56.5 114.1 199.4-27.7-17.8-38.8-31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m308.3 338.8c4 7.4 8.3 16.2 12.2 26 4 9.7 7.7 20.3 11.1 31 3.3 10.7 6.3 21.5 8.8 31.7 2.4 9.7 4.3 18.8 5.8 26.8q-0.8-0.7-1.6-1.4c-1.7-7.5-3.8-15.9-6.1-24.9-2.6-10.1-5.6-20.9-9-31.5-6.5-21.4-14.6-42.2-22.3-57.1-3.9-7.4-7.4-13.4-10.3-17.4q-2.8-4-4.6-6.2 1.9 2.1 4.9 6c3 3.8 7 9.6 11.1 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m431.1 320.4q-1.5 4-2.8 8-0.9-0.2-2-0.2c-9 0-9.9 12.9-2.3 14.9-1.6 6.2-2.9 12.4-3.5 18.2-4.2 36.5-33 66.9-44.1 80.2q-11.1 13.3-38.8 31.1 2.2-142.9 114.1-199.4-7.9 15-15.8 34.6c-6.5 0.7-8.2 8.5-4.8 12.6zm-22.5 29.4c-9.7 0-10 15.2-0.2 15.2 9.7 0 10-15.2 0.2-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m411.9 321.8q3-3.9 4.9-6-1.8 2.2-4.6 6.2c-2.9 4-6.4 10-10.3 17.4-7.6 14.9-15.8 35.7-22.3 57.1-3.4 10.6-6.4 21.4-9 31.5-2.3 9-4.4 17.4-6.1 24.9q-0.8 0.7-1.6 1.4c1.5-8 3.4-17.1 5.8-26.8 2.5-10.2 5.5-21 8.8-31.7 3.4-10.7 7.1-21.3 11.1-31 3.9-9.8 8.2-18.6 12.2-26 4.1-7.4 8.1-13.2 11.1-17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m322.3 772.3q15.5-74.6 17.7-86.4c2.2-11.8 4.1-57.6 21.4-61.6q17.4-4.1 34.9 14.6-42.1 12.2-53.4 46.3-11.4 34-18.3 87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m511.8 738.6c-5-0.8-45.7-51.8-68.7-71.4-23-19.7-41.1-27.3-46.8-28.3q-5.7-0.9-34.9-14.6 10.9-4.4 27.2-1.5c16.2 2.8 37.1 0.8 43-1.4 3.1-1.2 12.5-0.1 23.7 5.8-0.4 0.9-0.7 1.9-0.7 3 0 4.1 3.3 7.7 7.5 7.7h0.5c2.1 0 4.1-0.8 5.5-2.2 6.5 5.4 13 12.4 18.7 21.8 20.3 32.7 29.9 81.9 25 81.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m510.4 732c-17.3-76.1-71.5-100.5-97.5-108 2.7-0.1 2.1 0 4.4-0.2q83.5 29.8 93.1 108.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m312.2 772.3q-7-53.1-18.3-87.1-11.4-34.1-53.5-46.3 17.6-18.7 34.9-14.6c17.4 4 19.2 49.8 21.4 61.6q2.3 11.8 17.8 86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m240.4 638.9c-5.6 1-23.8 8.6-46.7 28.3-23 19.6-63.7 70.6-68.7 71.4-5 0.8 4.7-48.4 24.9-81.1 20.2-32.7 49.4-38.3 55.3-36.1 5.9 2.2 26.8 4.2 43 1.4q16.2-2.9 27.1 1.5-29.2 13.7-34.9 14.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m219.5 623.8c2.3 0.2 1.7 0.1 4.3 0.2-25.9 7.5-80.2 31.9-97.4 108q9.5-78.4 93.1-108.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m551.2 484.4q-39.9-29.6-82.7-1.9c-5.7 3.7-10.7 7.2-15.3 10.6-1.1-2.1-3.2-3.8-6.4-3.8-7.5 0-9.4 9-5.4 13.1q-3 2.6-5.8 5c-1-0.5-2.3-0.9-3.7-0.9-6.2 0-8.6 6.1-7 10.6-13.4 12.4-25.9 24-48 36.3-40.9 22.9-43.9 69-43.9 89.7 0 20.7-9.2 37.3-8.1 50.9q1.1 13.7-2.6 78.3h-4.4q-0.8-157.6 4.4-168.1c5.2-10.6 25.5-67.4 29.5-85.1q4.1-17.8 2.6-28.1 11.8-26.2 45.8-32.8c33.9-6.7 45.8-10.4 57.2-17.8 11.5-7.4 72.7-12.2 93.8 44zm-145.3 17.1c-9.8 0-10.1 15.2-0.3 15.2 9.8 0 10.1-15.2 0.3-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m481.5 462q5.2 0.1 8.1 0.2-2.9-0.1-8.1 0c-2.6 0.2-5.7 0.1-9.3 0.6q-5.4 0.6-12 1.8c-4.3 0.9-9 2-13.9 3.4-4.9 1.4-10 3.2-15.1 5.1-5.2 2.1-10.5 4.4-15.7 6.9-5.2 2.5-10.5 5.3-15.6 8.2-18.4 10.2-35.4 22.5-48.6 33q0.1-0.5 0.3-1c13-10.6 29.7-22.8 47.7-33 5.2-2.9 10.5-5.6 15.8-8.1 5.3-2.5 10.6-4.8 15.8-6.7 5.2-2 10.3-3.7 15.2-5.1 4.9-1.4 9.6-2.4 14-3.3 4.4-0.8 8.4-1.3 12-1.6 3.6-0.4 6.8-0.3 9.4-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m334.2 765h-4.4q-3.7-64.6-2.6-78.2c1.1-13.7-8.1-30.3-8.1-51 0-20.6-3-66.8-44-89.7-40.9-22.8-48.7-43.1-91.5-70.8q-42.8-27.7-82.7 1.8c15-40 50.4-49 73.7-48.2-1.8 4.4 0.3 10.6 6.6 10.6 5.4 0 7.8-4.6 7.3-8.7 2.7 0.7 4.8 1.5 6.2 2.4 11.4 7.4 23.2 11.1 57.2 17.7q33.9 6.7 45.7 32.9-1.4 10.3 2.6 28c4.1 17.7 24.4 74.6 29.6 85.1q5.1 10.6 4.4 168.1zm-87.8-314.8c-9.8 0-10.1 15.2-0.3 15.2 9.8 0 10.1-15.2 0.3-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m179.9 455.2c3.6 0.2 7.7 0.8 12.1 1.6 4.3 0.8 9.1 1.9 14 3.3 4.9 1.4 10 3.1 15.2 5 5.2 2 10.5 4.3 15.8 6.8 5.3 2.5 10.6 5.2 15.7 8.1 18.1 10.2 34.8 22.4 47.8 33q0.1 0.5 0.3 1c-13.2-10.6-30.2-22.9-48.6-33.1-5.1-2.9-10.4-5.6-15.6-8.2-5.3-2.5-10.5-4.8-15.7-6.8-5.2-2-10.2-3.7-15.1-5.2-4.9-1.4-9.6-2.5-13.9-3.4-4.4-0.7-8.4-1.4-12-1.7-3.6-0.5-6.7-0.5-9.3-0.7q-5.2 0-8.2 0.1 3-0.2 8.2-0.3c2.6 0.2 5.7 0.1 9.3 0.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m399.4 397.8q16.9-8.3 36.2-8.1c19.4 0.2 25.5-5.7 31.8-8.3 6.3-2.6 61.4 5 93.9 47.4q-40.2-21.8-92.8-27.1-52.6-5.4-45.6-2.2l-16.6 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m317.9 772.3q0.7-141.8 0-183.8c-0.8-42.1 15.5-127 25.1-151.4 9.6-24.4 70.5-59.4 125.5-35.4q-34 0.3-42.8 10.7c-8.9 10.3-30.7 36.9-43.2 46.1-12.6 9.2-18.1 70.2-33.6 101.2-15.5 31-25.1 44.6-26.6 70.1q-1.5 25.5-2.5 142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m175.1 292.6q51.2-8.3 76.1 23.2c25 31.6 85.1 109.7 66.6 156.8q-18.4 47 0.1 115.9-19-37.4-16.8-96.9c2.2-59.5-31-66.7-55.9-128.7-25-62-42.1-67.5-70.1-70.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m317.6 587.5l0.3 184.8h-2.4l-1-199.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m337.6 629.1q3.1 18.4-7.8 55v88.2h-2.7v-86q-12.4-28.4-28.2-34.7 29.3-21.1 38.7-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m302.4 647.9q3.1-40.1-10.5-54.4c-13.6-14.3-50.1-18.4-64.5-52.1q-14.4-33.7-30.8-54.7 74.2 16.9 95.3 54.7 21.2 37.8 16 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m243.8 503.2q-44.6-18-78.3-6.7-33.7 11.2-38.8-9.8 2 5.7 37.2-2.5c35.3-8.2 61.7 4.3 79.9 19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m415.4 692.3l-37.7 286.5h-111l-22.6-286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m244.1 692.3h171.3l-168.4 36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m389.7 887.5l-12 91.3h-111l-1.4-17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m402.4 781.2l0.8 3.8-13.4 101.5c-34.8-2.2-90.5-5.5-131-7.7l-2-25.7q57.3-28.3 145.6-71.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m286.1 621q24.9 11 51.5 8.1-64.2 25.1-64 177.9-37.3-95.1 12.5-186z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m304.9 626.9c-0.6 0.8-1.1 1.6-1.7 2.5-2 3.1-3.9 6.7-6 10.4-1.9 3.8-4.1 7.7-6 12q-1.4 3.2-2.9 6.4-1.3 3.4-2.6 6.8c-1.9 4.4-3.2 9.2-4.8 13.9-1.5 4.7-2.6 9.6-3.9 14.3-1.1 4.7-1.8 9.4-2.7 14-0.8 4.6-1.2 9-1.8 13.3-0.7 4.2-0.6 8.2-0.9 11.9-0.2 3.7-0.6 7.1-0.5 10.2 0 3 0.1 5.6 0.1 7.8q0 4.3 0 6.8-0.1-2.4-0.4-6.8c-0.1-2.2-0.3-4.8-0.5-7.8-0.3-3.1 0-6.5 0-10.2 0.2-3.8 0-7.8 0.6-12.1 0.4-4.3 0.7-8.8 1.5-13.4 0.8-4.6 1.6-9.4 2.6-14.2 1.3-4.8 2.3-9.7 3.8-14.4 1.6-4.8 3-9.6 5-14.1q1.3-3.4 2.7-6.8 1.5-3.3 3-6.4c1.9-4.3 4.3-8.2 6.3-12 2.2-3.6 4.2-7.2 6.4-10.2 0.5-0.8 1-1.5 1.5-2.2q0.6 0.1 1.2 0.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m581.6 501.2c-4.9 15.6-10.4 31-15.4 46.6-2.8 8.5-8 14-17.1 12.5-15.8-2.8-31.7-1.6-47.5-1.7-5.1 0-10 0-12.3-6.3-4.3-11.7-8.8-23.3-13.2-34.9-0.7-5.4-1.2-10.9-1.5-16.3 1.8-8.1 4.9-15.3 9.4-21.5 3.7-2.4 7.6-4.4 11.6-6.2 23.2-4.2 46.6-1 69.9 1.8 14.4 1.7 20.6 11.9 16.1 26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m534.8 704.4c-7.1 21.5-16.5 42.2-13.9 65.9 0.7 7.1-4.7 11.5-11.9 11.8-19.4 1.1-38.8 1.9-58.2 2.7-5.9 0.3-10.4-2.7-13.9-7.2-14.6-18.6-29.1-37.4-43.9-55.9-5.8-7.4-5.5-15.2-2.6-23.3 8.2-23 18.6-44.8 32.5-64.6 9-6.3 18.7-8.9 28.6-8.8 11.4 2.8 22.7 5.8 33.2 10.6 5.7 4.4 12 8.1 18.5 11.5q2.1 1.7 4.1 3.7c0.6 0.6 1.3 0.8 2 0.8 11.2 8.6 21.3 18.2 28.2 30.9 0.8 6.9-0.2 14.2-2.7 21.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m802.9 780.6c-17.6-0.5-35.2-2.8-52.3 4.4-5.1 2.1-9.6-0.9-11.5-6.2-5.1-14.3-10-28.6-15-42.8-1.5-4.4-0.3-8.4 2.3-12 10.6-15.1 21.4-30.2 31.9-45.3 4.2-6 10.1-7.5 16.8-7.2 19 1 37.6 3.9 55.5 9.9 6.7 5.2 10.8 11.9 13 19.3 0.4 9.2 0.7 18.3-0.5 27.2-2 5.2-3.4 10.7-4.5 16.3q-0.8 2-1.8 3.9c-0.3 0.6-0.3 1.2-0.1 1.7-4 10.3-8.9 20-16.8 28-5 2.1-10.7 3-17 2.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m869.9 446.1c4.2-13.2 8.8-26.2 13-39.3 2.3-7.1 6.7-11.8 14.4-10.4 13.3 2.3 26.6 1.2 40 1.3 4.3 0 8.4 0.1 10.3 5.3 4.6 12.7 9.7 25.2 14.3 37.8q0.6 1.6 0.9 3.2c-1.1 8.5-10.1 16.1-16.4 22.1-5.1 1.9-10.3 3.5-15.6 4.7-15.7 1.1-31.5-1-47.3-2.9-12.1-1.4-17.3-10-13.6-21.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1349.8 227.3c4.2-13.1 8.8-26.1 13-39.3 2.3-7.1 6.7-11.8 14.4-10.4 13.3 2.3 26.6 1.3 40 1.3 4.3 0.1 8.4 0.1 10.3 5.4 4.6 12.6 9.7 25.1 14.3 37.7q0.6 1.6 0.9 3.3c-1.1 8.4-10.1 16-16.4 22-5.1 1.9-10.3 3.6-15.6 4.7-15.7 1.1-31.5-1-47.3-2.8-12.1-1.5-17.3-10.1-13.6-21.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m1226 708.1c-1.9 10.5-7 19.5-13.2 27.9-5.4 7.4-12.3 11.1-22.1 10.6-23.7-1.4-47.5 1.3-71.2-2.1-10-1.5-12.9-7.2-9.5-17.4q1-1 2-1.9h-0.2c1.4-8.6 5.6-17 2.3-26.1-4.1-11.9-11.6-21-21.8-28q-1.3-1-2.6-2-0.9 0.4-1.8 0.7c0.1-4.7-3.7-5.5-6.8-7q-0.2-1.6-1.8-1.8-0.9-0.8-1.7-1.6-1.5-2.7-3-5.4c-1.8-16.2 1.2-19.3 17.3-16.4 14.1 2.6 27.8 2.4 41.4-2.6 9.8-3.5 19.9-1.8 29.8 0.2 16 3.1 31.6 8.1 46.9 13.6 9.8 3.5 15.2 10.8 15.4 21.6 5 12.5 4.2 25.1 0.6 37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m1079.2 661q0 0 0.1 0 0 0.1 0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m1081 662.8q0 0 0.1 0 0 0.1 0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m1077.7 659.4q-0.1 0-0.1 0 0 0-0.1-0.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m1192.4 499.4c-2.5 14.2-9.5 26.4-17.8 37.7-7.4 10-16.8 15.1-30 14.4-32.1-1.9-64.4 1.8-96.4-2.9-13.6-1.9-17.5-9.7-12.9-23.6q1.3-1.2 2.7-2.4l-0.2-0.1c1.8-11.7 7.5-23 3-35.3-5.5-16.1-15.7-28.5-29.6-37.9q-1.7-1.4-3.4-2.7-1.2 0.4-2.5 0.9c0.1-6.4-5-7.5-9.2-9.5q-0.3-2.1-2.5-2.4-1.1-1.1-2.1-2.2-2.1-3.6-4.2-7.3c-2.5-22 1.6-26.2 23.5-22.3 19.1 3.5 37.6 3.4 56.1-3.4 13.3-4.9 26.9-2.5 40.3 0.1 21.7 4.3 42.8 11 63.6 18.5 13.3 4.8 20.6 14.7 20.9 29.2 6.7 17 5.6 34.1 0.7 51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m993.6 435.6q0.1 0.1 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m996 438q0 0 0.1 0 0 0.1 0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m991.3 433.2q0.1 0.1 0.2 0.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m518.2 335.1q-0.1 0-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m584.9 305.1c5.6 2.5 10.9 5.4 16.3 8.3 10.4 5.5 20.9 9.6 32.9 10.2 11.2 0.7 13.8 4.4 13 15.4-0.8 15.9-1.7 31.9-2.6 47.8-0.3 5.2-3.3 8.9-7.5 11.7q-25.3 16.8-50.6 33.5c-7.4 4.9-14.6 2.1-21.1-1.4-21.4-11.5-40.7-25.9-57.4-43.5-1.3-1.4-2.1-3.3-4.2-3.7v0.1q-0.7-2-1.5-4-0.7-1.1-1.4-2.3l-0.1-0.1c0-1.9-0.9-3.4-2.5-4.5-4-9.5-0.9-16.9 6.1-23.8 4.6-4.5 11.1-7.3 13.9-13.7q1.1-0.8 2.2-1.6l-0.1 0.1q1.1-0.9 2.2-1.7l0.1-0.1q0 0-0.1 0.1 11.9-10.2 23.7-20.4c11.2-12 24.4-12.8 38.7-6.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m591.3 811.5q0 0 0.1 0 0 0.1 0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m565.3 726.6c3.9-6.3 8.2-12.3 12.5-18.4 8.1-11.6 14.6-23.7 17.3-38 2.5-13.5 7.3-15.9 20.4-13.4 19.1 3.5 38.2 6.9 57.2 10.4 6.3 1.2 10.2 5.3 13 10.8q16.3 33 32.7 66c4.8 9.7 0.2 17.9-4.9 25.2-17.1 24-37.3 45.1-61.1 62.6-1.8 1.3-4.3 1.9-5.1 4.4h0.2q-2.5 0.7-5.1 1.3-1.5 0.7-3 1.4h-0.1c-2.3-0.2-4.3 0.6-5.9 2.3-11.9 3.4-20.4-1.4-27.6-10.9-4.8-6.3-7.2-14.4-14.4-18.8q-0.9-1.5-1.7-2.9l0.1 0.1q-0.8-1.4-1.7-2.9 0 0 0 0.1l-0.1-0.2q0.1 0 0.1 0.1-10.5-15.8-20.9-31.6c-12.8-15.3-11.7-31.3-1.9-47.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1250.7 677.3q0 0.1-0.1 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1309.1 627.9c6.3 0.9 12.5 2.3 18.8 3.6 11.9 2.5 23.7 3.6 36 0.8 11.5-2.6 15 0.4 17.5 11.6 3.7 16.3 7.5 32.6 11.2 48.9 1.2 5.3-0.7 9.9-4.2 13.9q-20.6 24.2-41.1 48.4c-6 7-14.1 6.2-21.6 4.6-24.8-5.4-48.4-14.3-70.3-27.1-1.7-1-3-2.8-5.3-2.6l0.1 0.2q-1.4-1.8-2.7-3.6-1.1-1-2.2-1.9v-0.1c-0.6-1.9-1.9-3.2-3.9-3.8-6.7-8.4-5.8-16.7-0.7-25.6 3.3-5.9 9-10.6 10-17.9q0.9-1.1 1.7-2.3l-0.1 0.2q0.9-1.2 1.8-2.4 0 0.1 0 0.1l0.1-0.2q-0.1 0.1-0.1 0.1 9-13.6 17.9-27.3c7.8-15.3 20.8-19.9 37.1-17.6z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m582 669.9c-14.5 15.3-34.3 10.9-44.8-8.2-7.9-6.3-10.9-15-11-24.6-0.2-20.3 5.3-39.9 8.8-59.7 1-6 5.8-9.2 10.9-6.2 24.1 14.2 51.5 23.7 70.1 46.5q2.3 2.7 4.7 5.5v-0.1c-8.7 19-24.8 32.2-38.7 46.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m656.7 596.7c-18.9 4.7-20.1-2.7-26.5-28.6-6.5-25.8-15.8-60.3 3.1-65 18.9-4.7 39.5 12.4 46 38.2 6.4 25.9-3.7 50.6-22.6 55.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m699.3 663.3c-34.7-13.8-28.1-26.6-9.2-74 18.9-47.4 43.1-111.4 77.8-97.6 34.7 13.9 47.4 63.5 28.5 110.9-18.9 47.4-62.4 74.6-97.1 60.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m247.7 741c-34.7-13.9-28.2-26.7-9.3-74.1 19-47.4 43.2-111.4 77.9-97.6 34.6 13.9 47.4 63.6 28.4 110.9-18.9 47.4-62.4 74.6-97 60.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1024.7 492c4.2 19-3.2 20-29.2 25.8-26 5.9-60.7 14.4-64.9-4.6-4.3-19.1 13.3-39.2 39.2-45.1 26-5.8 50.6 4.8 54.9 23.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1346.9 179.1c4.3 19-3.1 20-29.1 25.8-26 5.9-60.7 14.4-65-4.6-4.2-19 13.3-39.2 39.3-45.1 26-5.8 50.6 4.9 54.8 23.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1125.7 620.1c-8.8 17.4-15.2 13.4-39 1.4-23.7-12-55.9-27.5-47.1-44.9 8.8-17.4 35.2-21.8 59-9.8 23.7 12 35.9 35.9 27.1 53.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m859.2 542c-16.8 9.8-20 3.1-33.5-19.9-13.5-22.9-32.2-53.4-15.4-63.3 16.7-9.8 41.3 0.7 54.8 23.7 13.5 22.9 10.9 49.6-5.9 59.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m365.2 224.4c-16.8 9.9-20 3.1-33.5-19.9-13.5-22.9-32.2-53.3-15.4-63.2 16.8-9.9 41.3 0.7 54.8 23.6 13.6 23 10.9 49.6-5.9 59.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m719.6 328.5c4.1-13.2 8.7-26.2 13-39.3 2.3-7.2 6.7-11.8 14.3-10.5 13.3 2.4 26.7 1.3 40 1.4 4.3 0 8.4 0 10.4 5.3 4.6 12.7 9.6 25.1 14.2 37.8q0.6 1.6 0.9 3.2c-1.1 8.4-10.1 16.1-16.4 22.1-5.1 1.9-10.3 3.5-15.6 4.7-15.7 1.1-31.5-1-47.2-2.9-12.2-1.4-17.4-10-13.6-21.8z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m754.8 237q0 0.1 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m731.7 152.9c3.7-6.4 7.9-12.4 12-18.6 7.8-11.6 14.1-23.8 16.9-38.1 2.5-13.4 7.1-16 19.4-13.7 17.8 3.2 35.7 6.3 53.6 9.6 5.9 1 9.5 5 12 10.5q14.8 32.6 29.7 65.2c4.4 9.5-0.1 17.8-5 25.1-16.5 24.2-35.8 45.5-58.4 63.3-1.8 1.4-4.1 2-4.9 4.5h0.2q-2.4 0.7-4.8 1.3-1.5 0.8-2.9 1.5h-0.1c-2.2-0.2-4 0.7-5.5 2.4-11.3 3.6-19.2-1.1-25.9-10.4-4.4-6.2-6.5-14.3-13.2-18.5q-0.8-1.5-1.5-2.9l0.1 0.2q-0.8-1.5-1.6-2.9l-0.1-0.2q0.1 0.1 0.1 0.2-9.6-15.6-19.2-31.2c-11.7-15-10.5-31-0.9-47.3z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m847 412.5c-2.4 11.5-11 15.4-21.5 16-22.5 1.3-44.9-1.3-67.2-2.9-13.2-1-26.2-2.5-39.3-3.9-9.8-1.1-17.8-5-22.3-14.5-9.8-15.2-5.7-30.5 0.4-45.5 2.4-5.8 7.9-6.9 13.6-6.7 6.2 0.2 12.3 0.4 18.5 0.6 9.7 0.5 19.3 1.2 29 1.5 15 5.2 31.9 6.3 47.1 3.5 0.8-0.2 1.3-0.5 1.6-1 6.2-0.2 12.3-0.5 18.5-0.3 17.1 0.3 17.4 0.1 20.8 17.5 3.8 11.8 3.3 23.8 0.8 35.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1432.4 587.3c7.7 1 10.9 7.4 12.2 15.5 2.7 17.2 3.1 34.7 3.9 52.1 0.5 10.2 0.6 20.3 0.9 30.5 0.1 7.6-1.7 14.1-7.4 18.3-9 8.6-19.2 6.6-29.4 2.9-3.9-1.4-5.1-5.6-5.5-10-0.3-4.8-0.8-9.5-1.2-14.3-0.5-7.5-0.9-15-1.5-22.5 2-11.9 1.3-25.1-1.8-36.6-0.2-0.6-0.5-0.9-0.8-1.2-0.6-4.7-1.4-9.4-1.8-14.2-1.3-13.2-1.4-13.4 9.5-17.3 7.3-3.8 15.1-4.2 22.9-3.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m811.5 266.3c13.5-8.3 27.7-14.3 43.7-15.3 9-2.5 15.1 2.3 20 8.5 18 22.6 31.4 48 44.8 73.4 4.1 7.7 5.4 16.2 0.4 24.5-6 14.9-19.4 20.7-32.9 25.7-7.9 2.9-14.2 0.2-18.6-7.4-18.5-31.9-38.6-62.7-61-92-5.4-7.2-3.8-12.9 3.6-17.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m954.5 340.3c-16.8 9.9-20 3.1-33.5-19.8-13.5-23-32.2-53.4-15.4-63.3 16.8-9.9 41.4 0.7 54.9 23.7 13.5 22.9 10.8 49.5-6 59.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1138.3 607.2c4.1-13.1 8.8-26.1 13-39.3 2.3-7.1 6.7-11.8 14.3-10.4 13.3 2.3 26.7 1.3 40 1.3 4.3 0.1 8.5 0.1 10.4 5.4 4.6 12.6 9.7 25.1 14.3 37.7q0.5 1.6 0.8 3.3c-1.1 8.4-10.1 16-16.4 22-5.1 1.9-10.2 3.6-15.5 4.7-15.8 1.1-31.6-1-47.3-2.8-12.2-1.5-17.4-10.1-13.6-21.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1425 574.4c-16.8 9.9-20 3.1-33.5-19.9-13.5-22.9-32.2-53.4-15.4-63.2 16.8-9.9 41.3 0.7 54.9 23.6 13.5 23 10.8 49.6-6 59.5z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m246.9 372.8q0.1 0 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m220.9 287.9c3.8-6.3 8.2-12.4 12.4-18.4 8.2-11.6 14.7-23.7 17.3-38.1 2.5-13.4 7.3-15.9 20.5-13.3 19 3.4 38.1 6.9 57.2 10.4 6.2 1.2 10.2 5.3 12.9 10.8q16.4 33 32.8 66c4.8 9.6 0.2 17.9-4.9 25.1-17.1 24.1-37.4 45.1-61.1 62.6-1.9 1.4-4.3 2-5.2 4.5h0.3q-2.6 0.6-5.1 1.3-1.5 0.6-3 1.3l-0.1 0.1c-2.4-0.3-4.3 0.6-5.9 2.3-12 3.4-20.4-1.4-27.6-10.9-4.8-6.3-7.2-14.5-14.5-18.8q-0.8-1.5-1.6-2.9l0.1 0.1q-0.9-1.4-1.7-2.9l-0.1-0.1q0 0 0.1 0.1-10.5-15.8-21-31.6c-12.7-15.4-11.7-31.4-1.8-47.6z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m346 550.1c-2.4 11.5-11.1 15.4-21.5 16-22.5 1.3-44.9-1.2-67.3-2.9-13.1-1-26.2-2.5-39.2-3.9-9.8-1.1-17.9-4.9-22.3-14.4-9.8-15.3-5.8-30.6 0.4-45.6 2.4-5.8 7.8-6.9 13.6-6.7 6.1 0.3 12.3 0.4 18.4 0.6 9.7 0.5 19.4 1.2 29 1.5 15 5.2 32 6.3 47.2 3.5 0.7-0.2 1.3-0.5 1.6-1 6.1-0.1 12.3-0.5 18.4-0.3 17.1 0.3 17.5 0.1 20.9 17.5 3.8 11.9 3.2 23.8 0.8 35.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m502.6 606.5c-2.6 9.1-11.2 12.1-21.6 12.3-22.3 0.6-44.5-1.9-66.7-3.7-13-1.1-25.9-2.6-38.8-4-9.7-1-17.6-4.3-21.9-12-9.4-12.5-5.2-24.6 1.2-36.5 2.5-4.6 7.9-5.4 13.6-5.1 6.1 0.3 12.2 0.6 18.3 0.8 9.6 0.7 19.2 1.4 28.8 1.9 14.7 4.5 31.5 5.7 46.7 3.8 0.7-0.1 1.2-0.4 1.5-0.8 6.2 0 12.3-0.1 18.3 0.1 17 0.6 17.3 0.5 20.4 14.6 3.6 9.5 2.8 19.1 0.2 28.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m310.5 403.9c13.4-8.3 27.7-14.2 43.6-15.2 9-2.6 15.2 2.2 20.1 8.4 17.9 22.6 31.3 48 44.8 73.4 4.1 7.7 5.4 16.2 0.4 24.5-6.1 15-19.4 20.7-33 25.7-7.9 2.9-14.2 0.2-18.6-7.4-18.5-31.9-38.6-62.7-60.9-92-5.5-7.2-3.9-12.9 3.6-17.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m453.5 477.9c-16.8 9.9-20 3.1-33.5-19.8-13.6-23-32.2-53.4-15.4-63.3 16.7-9.9 41.3 0.7 54.8 23.7 13.5 22.9 10.9 49.6-5.9 59.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m905.3 475.9c19 4.2 11.4 16.3 8.3 30.1-3 13.8-0.4 24.2-19.4 20-19.1-4.3-13.7-15.2-10.6-29.1 3.1-13.8 2.6-25.3 21.7-21z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1081 298.5c15.8 11.3 4.1 19.5-4.1 31-8.3 11.5-9.9 22.1-25.8 10.7-15.8-11.3-6.6-19.3 1.7-30.8 8.2-11.5 12.4-22.3 28.2-10.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1358.1 610.7c-34.5 0.1-69.1 0.1-103.6 0.5-6.5 0-8.7-2.5-9.4-8.6-5.6-43.9-9.9-87.9-8.7-132.2 0.7-25.7 11.2-48.5 23.2-70.6 7.1-13 13.9-26.2 20.9-39.2 5.7-10.6 10.5-11.8 20.4-5.2 11 7.4 17.4 18.8 24.5 29.5 13.1 19.6 29 37.7 36.1 61 8.1 55.1 2.5 110-3.4 164.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1107 292.2c4.2-13.2 8.8-26.2 13-39.3 2.3-7.1 6.7-11.8 14.3-10.4 13.4 2.3 26.7 1.2 40.1 1.3 4.3 0 8.4 0.1 10.3 5.3 4.6 12.7 9.7 25.2 14.3 37.8q0.6 1.6 0.9 3.2c-1.1 8.5-10.1 16.1-16.4 22.1-5.1 1.9-10.3 3.5-15.6 4.7-15.8 1.1-31.5-1-47.3-2.9-12.1-1.4-17.3-10-13.6-21.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m1363.6 411.5c-9.8-18.5-19.4-37.1-29.4-55.6-3-5.5-3.3-8.3 4-10.7 13.4-4.3 25.9-10.9 38.5-17.2 11.4-5.8 19-3 20.7 9.3 4.1 30.5 18.7 56.2 34.1 81.9 10.7 18 8.6 25.8-8 38.6-5.8 4.5-12.3 8.3-17.8 13.2-6 5.1-9.2 3.6-12.4-2.7-9.7-19-19.8-37.9-29.7-56.8z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1134.6 202q0 0.1 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1105.6 128c3.6-5.3 7.7-10.3 11.7-15.4 7.6-9.6 13.6-19.8 15.7-32 1.9-11.5 6.6-13.5 19.7-10.8 19 3.7 38 7.4 57 11.2 6.3 1.2 10.3 4.9 13.2 9.7q17.5 29 35 58c5.1 8.5 0.8 15.4-4 21.5-16 20-35.2 37.4-58.1 51.5-1.8 1.1-4.2 1.6-4.9 3.7h0.2q-2.5 0.4-5 0.9-1.4 0.5-2.9 1l-0.1 0.1c-2.3-0.3-4.2 0.3-5.7 1.7-11.8 2.5-20.3-1.9-27.8-10.4-5-5.5-7.7-12.7-15-16.7q-0.9-1.3-1.8-2.6l0.2 0.2q-0.9-1.3-1.8-2.6l-0.1-0.1q0 0 0.1 0.1-11-14-21.9-28c-13.3-13.7-12.8-27.4-3.7-41z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m966 294.1q0 0 0.1 0.1 0 0 0 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m940 209.3c3.9-6.3 8.2-12.4 12.5-18.4 8.1-11.6 14.6-23.7 17.3-38.1 2.5-13.4 7.3-15.9 20.4-13.4 19.1 3.5 38.2 7 57.2 10.5 6.3 1.2 10.2 5.3 13 10.8q16.3 33 32.7 66c4.8 9.6 0.2 17.9-4.9 25.1-17.1 24.1-37.3 45.1-61.1 62.6-1.8 1.4-4.3 2-5.1 4.5h0.2q-2.5 0.6-5 1.2-1.6 0.7-3.1 1.4l-0.1 0.1c-2.3-0.3-4.3 0.6-5.9 2.3-11.9 3.4-20.4-1.4-27.6-10.9-4.8-6.3-7.2-14.5-14.4-18.8q-0.9-1.5-1.7-3l0.1 0.2q-0.8-1.5-1.7-2.9l-0.1-0.2q0.1 0.1 0.1 0.2-10.5-15.8-20.9-31.7c-12.8-15.3-11.7-31.3-1.9-47.5z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m1234.5 376.2c-2.4 11.5-11 15.4-21.5 16-22.5 1.3-44.9-1.2-67.3-2.9-13.1-1-26.2-2.5-39.2-3.9-9.8-1.1-17.9-4.9-22.3-14.4-9.8-15.3-5.8-30.5 0.4-45.6 2.4-5.8 7.9-6.9 13.6-6.7 6.2 0.3 12.3 0.4 18.5 0.6 9.6 0.5 19.3 1.2 29 1.5 14.9 5.2 31.9 6.3 47.1 3.5 0.8-0.1 1.3-0.5 1.6-1 6.1-0.1 12.3-0.4 18.4-0.3 17.2 0.3 17.5 0.1 20.9 17.6 3.8 11.8 3.2 23.7 0.8 35.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1199 230c13.4-8.2 27.7-14.2 43.6-15.2 9-2.6 15.2 2.3 20.1 8.4 17.9 22.6 31.3 48.1 44.8 73.4 4.1 7.7 5.4 16.3 0.4 24.6-6 14.9-19.4 20.6-33 25.6-7.8 2.9-14.2 0.2-18.6-7.4-18.4-31.9-38.6-62.7-60.9-92-5.5-7.2-3.9-12.9 3.6-17.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1342 304.1c-16.8 9.8-20 3.1-33.5-19.9-13.5-22.9-32.2-53.4-15.4-63.3 16.8-9.8 41.3 0.7 54.8 23.7 13.6 22.9 10.9 49.6-5.9 59.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m833.4 570.7c19 4.2 9 27.1 3.4 52.3-5.5 25.2-4.6 43.1-23.6 38.9-19.1-4.2-11.5-24.7-6-49.8 5.6-25.2 7.2-45.6 26.2-41.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m387 621.7c19 4.2 9 27 3.4 52.2-5.6 25.2-4.6 43.2-23.7 38.9-19-4.2-11.5-24.6-5.9-49.8 5.6-25.2 7.1-45.5 26.2-41.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1397.8 258.6c19 4.2 11.4 16.3 8.4 30.1-3.1 13.9-0.5 24.2-19.5 20-19-4.2-13.6-15.2-10.6-29 3.1-13.9 2.7-25.4 21.7-21.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m668.1 502.1c2.2-7.4 16-13.1 27.9-9 19.2 6.5 17.8 14.3 15.7 21.8-2.2 7.4-13.7 10.5-25.7 7-12.1-3.5-20.1-12.4-17.9-19.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m576.4 562.1c2.1-7.4 16-13.1 27.8-9.1 19.3 6.6 17.9 14.4 15.7 21.8-2.2 7.4-13.7 10.6-25.7 7.1-12-3.5-20-12.4-17.8-19.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m934.6 156.9c9 6.6 5.8 33.4-9.9 53.2-25.3 32-35.5 26.5-44.5 19.9-8.9-6.7-3.9-28.4 11.1-48.6 15-20.2 34.4-31.2 43.3-24.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1076.3 671.8c12.9 0.2 28.1 21.8 26.8 44.5-2.2 36.8-15.6 38.2-28.5 37.9-13-0.3-23.1-19-22.6-41.7 0.5-22.8 11.3-41 24.3-40.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m591.4 274.1c3.1-10.7 34-15.6 62.8-6.4 46.7 14.9 45.5 26.5 42.4 37.2-3.1 10.7-29.2 12.4-58.3 3.9-29-8.5-50-24-46.9-34.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m652.3 461.1c0-11.2 35.4-24.5 73.4-23.7 61.5 1.3 64.1 12.8 64.1 23.9 0 11.1-30.8 20.1-68.8 20-37.9 0-68.7-9.1-68.7-20.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m409.8 526c3.1-10.7 22-19.1 38-13.7 26 8.9 23.9 20.2 20.8 30.9-3.1 10.7-18.8 15.5-35.1 10.7-16.2-4.7-26.8-17.2-23.7-27.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m708.4 687.3c1.4-4.8 10-8.6 17.3-6.2 11.8 4.1 10.8 9.2 9.4 14.1-1.4 4.8-8.5 7-15.9 4.8-7.4-2.1-12.2-7.8-10.8-12.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1228.4 631.1c1.4-4.9 10-8.7 17.3-6.2 11.7 4 10.8 9.2 9.4 14-1.4 4.9-8.6 7-15.9 4.9-7.4-2.2-12.3-7.9-10.8-12.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m357.9 249.8c1.4-4.9 10-8.7 17.3-6.2 11.8 4 10.8 9.2 9.4 14-1.4 4.9-8.5 7-15.9 4.9-7.4-2.2-12.2-7.9-10.8-12.7z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m695.7 243.9c2-6.9 14.2-12.3 24.5-8.8 16.8 5.7 15.4 13 13.4 19.9-2 6.9-12.1 10-22.6 6.9-10.5-3-17.3-11.1-15.3-18z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1221.2 395c4.9 0.3 9.3 24.1 7.2 49.2-3.4 40.6-8.6 42-13.6 41.6-4.9-0.3 12.4-28.6-5.8-46-39.9-38.3 7.2-45.2 12.2-44.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1435.3 293.8c4.9 0.4 9.2 24.2 7.1 49.2-3.3 40.7-8.6 42-13.5 41.7-5-0.4 12.4-28.7-5.8-46.1-39.9-38.3 7.2-45.1 12.2-44.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1056.1 379c-0.6 6.9-34 12.4-69.1 8.9-56.8-5.7-58.6-13-58-19.9 0.6-7 39.8 18 64.6-7.1 54.6-55.1 63.1 11.1 62.5 18.1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m595.6 484c-5-4.8 2.9-24.9 18-39.8 24.6-24.4 36.6-31.6 41.6-26.8 5 4.8 40.2 15.9-23.8 47.6-19.1 9.4-30.8 23.8-35.8 19z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1195.9 527.6c1.5-4.9 10-8.7 17.3-6.2 11.8 4 10.9 9.1 9.4 14-1.4 4.8-8.5 7-15.9 4.9-7.3-2.2-12.2-7.9-10.8-12.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m484 426.5c3.1-10.7 22.1-19.1 38.1-13.7 25.9 8.9 23.9 20.2 20.7 30.9-3.1 10.7-18.8 15.5-35 10.8-16.3-4.8-26.9-17.3-23.8-28z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m378 345.3c4.5-15.5 31.9-27.8 55-19.9 37.5 12.8 34.5 29.3 29.9 44.8-4.5 15.4-27.2 22.5-50.7 15.6-23.4-6.9-38.7-25-34.2-40.5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m962.8 842.2c-50.8 3.1-91.7 9.3-101.5-150.7-10.3-167.6 31.6-158.9 82.4-162 50.8-3.1 102.4 19.8 101.6 150.7-1.1 164.4-31.6 158.9-82.5 162z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m484.2 330.3c-0.8-0.2-1.6-0.4-2.5-0.6-5.5-1.8-11.1-3.8-16.4-6.1-14.8-6.6-29.7-11.2-46.4-10.2-11.9 0.7-16.5-4.1-16.8-15.8-0.5-19.4-0.3-38.8-0.6-58.1-0.2-7.3 3-12.7 8.5-17 16.8-13.2 33.6-26.4 50.3-39.6 9.9-11.5 21.6-12.1 34.7-6.2 26.4 11.9 51.1 26.7 72.7 46.1 5.8 6 8.1 13.4 8.2 21.2q-2.7 7.3-5.7 14.5c-6.8 9.8-14.5 18.9-21.5 28.6-12.6 12.3-25.3 24.5-38 36.7q-2.8 1.5-5.6 2.8c-6.7 2.5-13.7 3.9-20.9 3.7z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m556.2 193.7c-15.6-5-31.1-10.5-46.6-15.5-8.6-2.7-14.1-7.9-12.5-17 2.8-15.8 1.5-31.7 1.6-47.5 0.1-5.1 0.1-10 6.4-12.3 15-5.5 29.8-11.5 44.8-17q1.9-0.7 3.9-1c10 1.3 19 11.9 26.2 19.4 2.3 6.1 4.2 12.2 5.6 18.6 1.3 18.7-1.2 37.4-3.4 56.1-1.7 14.5-12 20.6-26 16.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m624.7 239.7c-12.4-4.3-23.3-11.6-28.9-22.1q-1-2.3-1.7-4.6-0.1-1.7-0.3-3.4-0.1-51.8 0-103.7c1.1-0.9 1.5-2.6 0.2-3.9q-0.1 0-0.1 0c1.7-9.1 5.2-17.9 11.1-24.1 2.3-0.9 4.8-1.4 7.7-1.5 7.8-0.4 15.6 0.3 23.2 2.4 22.4 6.3 45 9 68.4 7.1 18-1.4 24 5.2 18.8 22-8.5 27.3-5.3 54.4-2.3 81.9 2.7 24.4-2.2 30.3-26.4 34.4-8.4 1.4-16.8 3-25.2 4.6q-4 2-8 3.8c-12 3.3-24 6.3-36.5 7.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m410.8 89.1c11.1-0.7 20-2.5 23.3 51.7 3.5 56.7-5.7 53.4-16.8 54.1-11.1 0.7-22.5-7.4-23.3-51.7-1-55.5 5.7-53.5 16.8-54.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1373.5 684l-2.3 1.8-34.8-63 2.3-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1354.2 576.5c10.8 32.6-5.6 71.3-34.5 60.9-29-10.5-50.3-63.5-53.1-93.8q-2.9-30.3 9.7-41.1c15-8.9 67.1 41.4 77.9 74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1353.1 573.6q0.6 1.5 1.1 2.9c10.8 32.6-5.6 71.3-34.5 60.9-29-10.5-50.3-63.5-53.1-93.8-0.5-4.7-0.5-8.9-0.3-12.7 7.7 29.7 26.1 66 49.5 74.5 20.4 7.3 34.5-9.7 37.3-31.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1352.4 648.6l-1.1 0.9-78.8-153 1.2-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1292 533.7l-34.5-4.6 0.1-1.7 34.5 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1287.7 523.5l-1.3-0.6 9.5-35.2 1.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1302.3 552l-1.2-0.7 16-43.7 1.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1309.3 566.9l-50.1 6.6-0.2-1.7 50-6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1316 578.5l-1.3-0.8c4.2-12.2 25.5-73.3 26-74.3l1.2 1c-0.6 1.3-17.2 49-25.9 74.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1323 593.6l-72.9 9.1-0.2-1.6 72.8-9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1328.2 602.4l-1.2-0.9 24.5-58.7 1.2 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1332 611.1l-49.3 7.3-0.2-1.7 49.2-7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1338.7 623l-1.1-1 32.5-59.1 1.1 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1342.4 631.1l-43.7 12.7-0.4-1.6 43.7-12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1298 545l-43.5 6.7-0.3-1.6 43.5-6.8z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1354.2 576.5c10.8 32.6-5.6 71.3-34.5 60.9-29-10.5-50.3-63.5-53.1-93.8q-0.2-2.4-0.3-4.6-0.1-0.9-0.1-1.7 0-1.1 0-2-0.1-24 10.1-32.8c15-8.9 67.1 41.4 77.9 74z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m1448.5 648.6q-65.6 15.6-78.3-19.3-12.7-34.9 26.7-28.9l18.8 11.2q11.3 5.6 10.9 6.5-0.4 0.9 8.5 7.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1366.6 640.7q-1.5-59.9 39.6-60.9 41.1-1 44.4 74.2-64.6-59.6-84-13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m1381 930.8q-62.9 0-72.4-22.2l-20.8-147h177.5l-20.8 147q-0.6 22.2-63.5 22.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    style: {
      opacity: 0.3
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m1474.8 726.6v42.4c0 6.3-7.9 12.1-21.1 16.7l-22.9 161-41.5 3.1 10.9-154.6c-7.6 0.5-15.5 0.8-23.7 0.8-54.2 0-98.2-12.1-98.2-27v-42.4c0 14.9 44 22.3 98.2 22.3 9.2 0 18-0.2 26.4-0.7v-0.9l6.4 0.6c38.1-2.5 65.5-9.5 65.5-21.3z"
  })))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1308.6 908.6q0.3 0.5 1.1 1.3c0.7 0.8 1.9 1.8 3.5 3 1.7 1.1 3.7 2.4 6.2 3.6 2.5 1.1 5.4 2.3 8.6 3.3 3.3 1 6.8 1.8 10.6 2.7 2 0.3 3.9 0.7 5.9 1 2.1 0.2 4.1 0.5 6.2 0.8 4.3 0.4 8.7 0.9 13.2 1.1q3.3 0.1 6.8 0.3 3.4 0.1 6.8 0.1l3.5 0.1 3.3-0.1q3.5 0 7 0c4.5-0.3 8.8-0.2 13.1-0.7 2.1-0.2 4.2-0.3 6.2-0.6q3-0.4 5.9-0.7 2.9-0.6 5.5-1.1c1.8-0.4 3.5-0.9 5.1-1.4 1.6-0.4 3.1-1.1 4.5-1.5 1.4-0.7 2.7-1.2 3.9-1.9 2.3-1.3 4.3-2.6 5.6-4.1 1.4-1.4 2.3-2.7 2.8-3.7q0.5-0.9 0.6-1.5 0 0.1 0 0.4c0 0.3 0 0.7-0.1 1.3-0.2 1.1-0.6 2.8-1.7 4.7-1 1.9-2.8 3.9-5 6-1.2 1-2.5 1.9-3.8 2.9-1.5 0.9-3 1.8-4.7 2.7-1.6 0.7-3.4 1.6-5.2 2.3-1.9 0.7-3.8 1.3-5.8 2q-3 0.8-6.2 1.6c-2.1 0.6-4.3 0.8-6.6 1.2-1.1 0.2-2.2 0.5-3.4 0.6q-1.7 0.2-3.4 0.4c-2.3 0.2-4.7 0.5-7.1 0.6q-3.4 0.1-6.9 0.3l-3.6 0.1-3.6-0.1q-3.6-0.1-7.2-0.2c-2.4-0.1-4.7-0.4-7.1-0.6q-1.7-0.1-3.5-0.3-1.7-0.3-3.4-0.5c-2.3-0.4-4.6-0.7-6.8-1.1-2.2-0.5-4.4-1-6.5-1.5-2.1-0.6-4.2-1.3-6.2-1.9-3.9-1.3-7.6-2.8-10.8-4.5-3.3-1.7-6.1-3.6-8.5-5.4-2.3-1.8-4.1-3.7-5.5-5.3-1.4-1.7-2.2-3.1-2.7-4.1q-0.5-1-0.6-1.6z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1376.6 676.5l-2.6-1.6c0.5-0.9 13-20.1 42.9-26.4l0.6 3c-28.6 6-40.7 24.8-40.9 25z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m1425.3 644.2q42.4-21.6 68.4 2.6 25.9 24.2 21 58.4-18.1-37.3-37.7-45.1-19.5-7.7-40.8-10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1412.3 651.2q22.4-16.6 46.9-11c24.6 5.6 55.7 40.5 55.7 69.5q-33.5-53.7-103.3-58.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m1514.5 703.6q0.4 3.1 0.4 6.1-33.5-53.7-103.3-58.3l0.7-0.2q20.7-15.3 44.2-11.5-10.2 1.2-17.5 4.3h-0.7c40.9 12.8 64.2 40.3 76.2 59.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1385.5 676.2l-1-1.2 61.3-47.9 1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1391.7 682.6l-0.9-1.3 79.9-56.3 0.9 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1405.6 690.7l-1-1.3 79.6-59 0.9 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1423.2 686.8l-0.7-1.3 84.2-44.3 0.7 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1438.8 686.2l-0.6-1.4 87.9-35.9 0.5 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1459.2 687.6l-0.4-1.5 75.1-20.2 0.4 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1477.4 690.7l-0.1-1.6 68.9-5 0.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1491.9 698.2v-1.5l59.8 2.3v1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1503.9 703.9l0.3-1.5 50.7 11.7-0.3 1.5z"
  })))))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1353.4 541.3q-0.4-68.9 43.5-100.2c43.9-31.3 61-28.2 53.8 2.4-7.2 30.5-3.6 93.4-51 105.3q-47.4 12-46.3-7.5z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m1364.8 595q-1.3-0.5-2.5-0.9c1.1-37.2-3.6-70.7-11.6-101.4q1.7-0.4 3.5-0.9c8 31.3 12.4 65.5 10.6 103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m1371.1 502.3c-14.6 12-29.6 9.4-44.3-2.6-29.5-24.3-41.4-74.8-44.1-110.5-2.2-34.7 0.6-56.4 0.9-56.2 1.9-8.4 20.3-1.8 45.6 17.6-1.5 3-0.1 7.6 4.3 7.6 1.5 0 2.7-0.5 3.5-1.3q1.6 1.3 3.2 2.6c-2.3 2.1-1.5 6.9 2.4 6.9 1.6 0 2.7-0.7 3.3-1.8 5.9 5.4 11.9 11.3 17.5 17.5-6.5 2.2-5.9 13.4 2.1 13.4 3.1 0 5.1-1.6 6.1-3.7 11.6 14.6 20.3 30.2 21.8 44.6 5.2 28.6-8.4 54.6-22.3 65.9zm-37.8-131.8c-5.1 0-5.2 7.8-0.2 7.8 5.1 0 5.2-7.8 0.2-7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m1392.3 431.5q0.7 2.5 1.1 4.9c5.2 28.6-8.4 54.6-22.3 65.9-14.6 12-29.6 9.4-44.3-2.6-29.5-24.3-41.4-74.8-44.1-110.5-0.4-5.4-0.5-10.4-0.7-15.1 8.8 35.3 21.2 72.9 47.5 89.9 21.9 15.1 50.3 3.9 62.8-32.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1360.7 533.4q-0.9 0-1.7-0.1c-9.5-79.3-41.3-142.5-80.5-207.7q0.2-0.9 0.4-1.7c40.3 65.6 72.6 129.4 81.8 209.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1305.9 372.9c-11.9 0.1-21.8 0.5-31.2 0.4q0-1 0-2c9.3 0 19.1-0.5 31-0.7q0.1 1.2 0.2 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1299.7 359.7q-0.6-0.3-1.3-0.5c0.1-17.3-2.2-36.7-9.1-56.5q0.8 0.2 1.5 0.4c6.9 19.8 9.1 39.3 8.9 56.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1319 396.6q-0.8-0.5-1.5-0.9c5.6-19.9 9.2-43.7 7.1-69.3q1 0.4 2 0.8c1.9 25.7-1.9 49.5-7.6 69.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1327.1 416.2c-20.8 2.2-37 4.4-53.3 5.2q0-0.9 0-1.7c16.2-0.9 32.3-3.3 53.1-5.7q0.1 1.1 0.2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1334.4 431.6q-0.7-0.5-1.5-1.1c2.7-6.7 15-31.9 19.8-60.5 5.9-27.8 4.1-59 3.3-58.8q1.4 0.6 2.8 1.2c0.2 0.4 2.3 25-2.5 50.9-4 26.3-14.9 53.8-21.9 68.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1341 452.1c-32.7-2.7-55.4-2.7-80.3-4q0-0.8 0.1-1.6c24.9 1.3 47.5 1.1 80.3 3.4q-0.1 1.1-0.1 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1345.9 464.5q-0.7-0.7-1.4-1.4c15.4-21 33.7-48.8 48.1-84.7q1.2 0.8 2.5 1.5c-14.9 35.9-33.5 63.7-49.2 84.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1348.5 476.6c-22.3-4.2-40.4-6.6-57.5-7.8q0-0.8 0-1.7c17.1 1.2 35.3 3.4 57.7 7.4q-0.1 1.1-0.2 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1353.6 494.1q-0.6-0.9-1.2-1.8c20.3-17.2 47-40.8 76.8-75.5q1.1 1.1 2.2 2.2c-30.4 34.6-57.3 58.1-77.8 75.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1355.4 505.8c-19.9-4.5-36.6-7.6-52.2-8.6q-0.1-0.9-0.1-1.7c15.6 1 32.4 3.9 52.4 8.1q-0.1 1.1-0.1 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1313.6 387.5c-15.9 4.8-28.8 8.9-42.1 11.3q0-0.9-0.1-1.7c13.2-2.6 26-6.9 41.8-11.9q0.2 1.2 0.4 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1368.6 620.8q-0.7 1.4-1.4 2.7c-14.8-17.6-32.4-33.3-52.1-46.6q0.9-1.7 1.8-3.5c19.6 13.4 37.2 29.4 51.7 47.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1317.2 515.4c24 26.5 18.7 79.1-14.8 88.9-34.4 11.7-78.4-20.6-95.8-40.7-17.3-20-10.4-34.3-10.3-34.9 9.7-19.5 96.4-43.2 120.9-13.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.4
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m1314.9 513.4q1.2 1 2.3 2c24 26.5 18.7 79.1-14.8 88.9-34.4 11.7-78.4-20.6-95.8-40.7-2.7-3.2-4.7-6.1-6.3-8.9 22.4 13.7 57.4 31.7 86.1 20.7 24.9-9.2 34-37.1 28.5-62z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1339.9 593.4q-0.4 0.8-0.9 1.6c-41.1-38.3-96-65.3-149.6-65.9q0.4-0.7 0.7-1.4c53.8 0.1 108.8 27.2 149.8 65.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1228.8 533.7c-13.2 9.5-26 18.7-38.4 27q-0.4-0.6-0.7-1.2c12.4-8.3 25.2-17.5 38.3-27.1q0.4 0.7 0.8 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1219.1 530.6q-0.8 0.4-1.7 0.8c-2.5-10.6-5.3-20.1-8.3-28.1q0.8-0.5 1.7-1c3 8.1 5.8 17.7 8.3 28.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1248.9 538.4q-0.9 0.2-1.8 0.5c-0.9-16.8-2.4-32.5-4.3-46.6q0.9-0.4 1.8-0.8c1.9 14.2 3.3 30 4.3 46.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1263.3 544.9c-17.5 16.8-34.6 33.6-51.1 49.4q-0.4-0.6-0.9-1.2c16.5-15.8 33.6-32.6 51-49.5q0.5 0.6 1 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1275.7 549.4q-0.9 0.2-1.7 0.4c0.4-16.9-6.1-85.3-6.8-84.2q0.9-0.3 1.8-0.6c0.5 0.2 6.3 52.1 6.7 84.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1289.7 557.9c-25.5 23.2-50.9 47.8-75 70.7q-0.4-0.7-0.9-1.4c24.1-22.9 49.5-47.5 74.9-70.8q0.5 0.8 1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1298.8 562.3q-0.8 0.1-1.7 0.2c1.4-26.2 2.4-52.3 2.5-77.1q0.9-0.2 1.8-0.4c-0.2 24.9-1.2 51.1-2.6 77.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1306.2 568.2c-16.8 15.2-33.8 31.3-50.6 47.6q-0.5-0.7-1-1.4c16.8-16.3 33.9-32.5 50.7-47.7q0.5 0.7 0.9 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1317.6 575.4q-0.8-0.2-1.6-0.2c4.7-28.4 9.2-57.5 13.3-86.2q0.8 0 1.7 0.1c-4.1 28.8-8.8 57.9-13.4 86.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1324.2 581.3c-13.7 14.5-27.8 29.9-41.9 45.8q-0.5-0.6-1-1.3c14.1-15.9 28.2-31.3 41.9-45.9q0.5 0.7 1 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m1240.8 536.7c-14.8 15.1-29.1 29.8-43 43.3q-0.5-0.5-1-1.1c13.8-13.5 28.2-28.2 42.9-43.3q0.5 0.6 1.1 1.1z"
  })))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m1291.5 535c-19.8 3-65.1-13.7-53-22.8q12-9.1 58.7 3.5c25.5 6.8 14 16.3-5.7 19.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m1232.4 516.1q-15.2-0.4-15 4c0.2 4.3 28.7-4.2 15-4z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }))))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m1468.3 751.6c0 7.7-55.2 12.3-91.8 12.3-36.5 0-91.7-4.6-91.7-12.3 0-7.6 55.2-13.8 91.7-13.8 36.6 0 91.8 6.2 91.8 13.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1441.7 593.6q-14.4-17.7-7.7-42.2 6.7-24.5 39.6 0 19.2 3.2 20.5 18.5c1.3 15.4-0.7 24.3-52.4 23.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m1358.5 755.2q-24.7-31.3-34.9-39.8c-10.2-8.4 24.3-4.2 41.7 3.5q17.5 7.8 0 44.5z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m1321.8 785.9q0.6 0 1.7 0c1.1 0 2.7 0.1 4.8 0 4.1 0 10-0.1 17-0.2 7-0.1 15.3-0.2 24.1-0.3 4.4 0 8.9-0.1 13.5-0.2 4.6-0.3 9.2-0.5 13.9-0.7 4.7-0.3 9.3-0.6 13.9-0.8 4.6-0.4 9.1-0.8 13.5-1.1 4.4-0.3 8.6-0.8 12.6-1.2 4-0.4 7.7-0.9 11.2-1.3 6.9-1 12.7-2 16.5-3.3 1.9-0.6 3.4-1.3 4.2-2 0.4-0.4 0.6-0.7 0.7-1q0.1-0.3 0.1-0.4c0 0 0.2 0.7-0.6 1.6-0.7 0.9-2.1 1.8-4 2.7-3.8 1.9-9.5 3.6-16.4 5.1-3.5 0.8-7.2 1.5-11.2 2.1-4 0.7-8.3 1.3-12.7 1.8-4.4 0.6-8.9 1-13.5 1.3q-7.1 0.6-14.1 0.9c-9.4 0.5-18.9 0.3-27.7 0-8.8-0.2-17-0.6-24-1-7.1-0.4-12.9-0.9-17-1.3-2.1-0.1-3.7-0.4-4.8-0.5q-1.1-0.1-1.7-0.2z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m1283.6 751.6c0 7.7 55.7 11.4 92.9 11.4 37.3 0 93-3.7 93-11.4v21.8c0 7.6-55.7 13.8-93 13.8-37.2 0-92.9-6.2-92.9-13.8z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m1439.1 742.3q0.8 0.1 2.4 0.2c1.6 0.2 4 0.4 7 0.8 2.9 0.4 6.6 1 10.7 2 2.1 0.5 4.2 1.1 6.5 2.1 1.2 0.6 2.4 1.1 3.5 2.6 0.2 0.4 0.4 0.9 0.5 1.5v0.1c0 0 0 0.4 0 0.2v0.2c0 0 0 0.1-0.1 0.2 0 0.3-0.2 0.7-0.3 0.9-0.5 0.9-1.1 1.5-1.7 1.9-2.5 1.7-5.1 2.5-7.9 3.4-2.7 0.8-5.5 1.4-8.5 2-5.8 1.2-12 2.1-18.4 2.9-6.5 0.7-13.1 1.4-19.9 1.8-6.8 0.5-13.6 0.9-20.5 1.1-6.9 0.2-13.8 0.2-20.6 0.1-6.8 0-13.5-0.4-19.9-0.7-12.9-0.8-24.9-2-35.1-3.5-10.3-1.5-18.7-3.3-24.5-5.2-2.9-1-5.1-2.1-6.3-3.1-0.6-0.6-1-1.1-1.1-1.5-0.2-0.4-0.1-0.7-0.1-0.7 0 0 0 0.3 0.1 0.6 0.2 0.4 0.6 0.9 1.3 1.3 1.3 0.9 3.5 1.7 6.4 2.4 5.8 1.3 14.3 2.4 24.5 3.2 10.2 0.9 22.2 1.5 35 1.9 6.4 0.2 13 0.3 19.7 0.3q10.2 0.1 20.4-0.3c6.9-0.2 13.7-0.4 20.4-0.8 6.7-0.5 13.3-0.9 19.7-1.4 6.4-0.7 12.5-1.3 18.3-2.2q4.3-0.6 8.3-1.5c2.5-0.7 5.2-1.4 7-2.5 0.4-0.3 0.8-0.6 0.9-0.8 0.1-0.1 0 0 0 0 0.1 0 0.1-0.1 0.1-0.2v-0.1c0-0.1 0 0.2 0 0.1-0.1 0 0-0.1-0.1-0.2-0.3-0.6-1.3-1.3-2.2-1.8-1.9-1-4-1.8-5.9-2.4-4-1.3-7.5-2.2-10.4-2.9q-5.9-1.4-9.2-2z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1377.7 749.4l23.2-0.9q-4.9-5.3 2.1-8.8 7-3.4 32.8 16.8-40.7-5.8-59.3-4.8z"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m1417.7 452.9q-39.4 51.8-46.1 72.7l-6.2-9.2q34.7-50.2 52.3-66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1410.2 462.2q32.6-71.8 30.6-100.1c-1.9-28.4 19-45.2 41.2-40.5 22.2 4.7 24.6 67.4-4 102.5-28.5 35.2-45 39.1-67.8 38.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1478.7 340.2l-13.9-22.5 1.1-0.7 13.9 22.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1512.4 333.7l-28.3-1.3 0.1-1.4 28.3 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1471.8 351.8l-23.9-26.4 1-0.9 23.9 26.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1512.4 347.4l-36.6-1.3 0.1-1.3 36.5 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1513.5 366.4l-47.9-3.2v-1.4l48 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1459 373l-27.1-32.8 1.1-0.8 27.1 32.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1509 387.8l-55.7-4.2 0.1-1.3 55.7 4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1446.8 393.4l-27.7-28.8 1-1 27.7 28.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1502.9 408.5l-62-4.3 0.1-1.3 62 4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1431.9 417.9l-18.2-24.6 1-0.8 18.3 24.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1488.5 434.2l-60.8-8.2 0.2-1.4 60.7 8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1472.2 453.6l-56.9-6.9 0.1-1.3 57 6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1458.1 465.2l-46.2-6.5 0.2-1.4 46.2 6.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1374.1 517.2l-2.3-1.4 121.6-202.1 2.3 1.4z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m1424.1 461.9c-4.5 0.5-9.1 0.5-13.9 0.3q32.6-71.8 30.6-100.1c-0.7-11.4 2.2-21 7.4-28-2.8 9.1-4.4 22-1.1 39.4 6.7 36.2 9.8 71.4-23 88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1442.4 407.8q-1.6 29.6-31.9 54.4-7-10.8 6-27c13-16.1 15.4-56.8 17.1-70.8q1.8-13.9 13.5-27.8c-8.4 30.7-3.2 41.6-4.7 71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m1490 345.3q-5.3 82.3-24.7 88.4c-19.3 6.1-12-19-2-37.6q10-18.6 26.7-50.8z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m1331.1 518.6q14.5 13 43.1 54.5l-5 7.6q-5.6-17.3-38.1-60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1281.3 496.9c-23.6-28.9-21.6-80.7-3.2-84.6 18.3-3.9 35.5 10.1 33.9 33.4q-1.6 23.4 25.3 82.7c-18.9 0.8-32.5-2.5-56-31.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1279.8 427.1l11.5-18.6 0.9 0.6-11.5 18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1252.9 421.2l23.3-1.1 0.1 1.1-23.4 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1285.6 436.5l19.7-21.8 0.8 0.8-19.7 21.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1252.9 432.5l30.2-1v1.1l-30.2 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1251.9 448.2l39.6-2.7 0.1 1.2-39.6 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1296.1 454.1l22.4-27.1 0.8 0.7-22.3 27.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1255.7 465.8l46-3.4v1.1l-46 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1306.2 470.8l22.9-23.8 0.8 0.8-22.9 23.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1260.7 482.9l51.2-3.5 0.1 1.1-51.2 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1318.5 491.1l15-20.3 0.9 0.7-15 20.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1272.5 504.2l50.1-6.8 0.2 1.1-50.1 6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1286 520.1l46.9-5.6 0.2 1.1-47 5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1297.6 529.7l38.1-5.4 0.1 1.1-38.1 5.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m1266.7 406.9l1.9-1.1 100.4 166.8-2 1.2z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m1306.8 455.2c2.7-14.4 1.4-25-0.9-32.6 4.3 5.9 6.7 13.7 6.1 23.1q-1.6 23.4 25.3 82.7c-4 0.1-7.8 0.1-11.5-0.3-27.1-14-24.5-43-19-72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1306.8 424.7q9.7 11.4 11.1 23c1.5 11.5 3.4 45.1 14.2 58.4q10.7 13.3 5 22.3-25.1-20.5-26.4-44.9c-1.2-24.4 3-33.4-3.9-58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m1293.5 473.8c8.2 15.4 14.3 36.1-1.7 31.1q-16-5.1-20.4-73.1 13.8 26.7 22.1 42z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1367.9 557.6l5.1 14.1 2.5 70.9q2.3-1.8 11.2-6.3c9-4.4 24.4-20.2 34.5-33.3q10.2-13.2 40.7-42.2-31.2 35.2-41.5 49.7-10.3 14.4-43.9 37.2l0.5 67.7-4 1.3h-7.7q2.7-26.4 0.4-34.8-2.3-8.4-19.5-15.3l-1-3.8 20.2 9.8q0.2-8.8-0.2-29.5-0.4-20.6-5.6-77.1z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1372.4 676.7l-2.7-1.4c0.8-1.7 22.1-41.7 45-58l1.8 2.5c-22.3 15.9-43.9 56.5-44.1 56.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1514.9 560.4q52.6 9.9 54.5 36.8c-52.4-26.6-148.9 25.1-156 25.4q-7.1 0.3 1.9-15.6c11.6-19.6 46.9-56.5 99.6-46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m1569.4 597.2c-52.4-26.6-148.9 25.1-156 25.4q-7.1 0.3 1.9-15.6c7.5-12.6 24.9-32.5 50.5-42.4-6 4.4-10.9 8.9-14.4 12.7q-11.9 13.8-4.9 14.9c5.3 0.9 65.8-16.7 115.1-9.9q7.3 8 7.8 14.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1415 625.9l-1.4-0.7 34.8-69.6 1.4 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1423.3 629l-1.3-0.8 47.9-85.2 1.4 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1439.4 630.3l-1.4-0.7 46.4-87.5 1.4 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1453.6 619.2l-1.2-0.9 57-76.2 1.3 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1467.5 612l-1.2-1.1 63.9-70.2 1.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1486.5 604.5l-1-1.2 59.1-50.6 1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1504.2 599.4l-0.8-1.3 60.1-34.2 0.8 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1520.5 600l-0.6-1.4 55-23.6 0.6 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m1533.8 599.9l-0.3-1.5 50.7-11.2 0.4 1.5z"
  }))))))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1203.1 634.1q3.4-3.6 2.5-10.6c-0.9-6.9-5.6-26.4 31.2-21.7 36.8 4.8 72.8 23 84.7 35.1 11.9 12 15.9 15 18 15.8 2.1 0.8 24.2 0.9 24.5 8.2 0.2 7.3-21.9 20.5-39.2 15.8-17.4-4.7-69.1-22.3-82.9-32.2-13.9-9.9-32.6-15.1-38.8-10.4z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1215.1 641.2l-1.3-0.2c2.2-16.1 14.6-20.7 14.8-20.8l0.4 1.3c-0.1 0-11.8 4.5-13.9 19.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1224.2 647.1l-1.4-0.2c2.5-16.4 19.4-25.8 20.1-26.2l0.6 1.2c-0.1 0.1-16.9 9.5-19.3 25.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1216.7 622.7c-0.2-0.4-4-9.1-17.8-5.9l-0.3-1.3c15-3.5 19.3 6.6 19.3 6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1233.8 621.1c-0.1-0.2-6.3-19.8-22.9-21.4l0.2-1.4c17.5 1.7 23.9 22.2 24 22.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1251.9 623.5h-1.4c0.3-15.3-14-27.8-14.1-28l0.8-1c0.7 0.5 14.9 13.1 14.7 29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1236.6 652.2l-1.4-0.3c3.4-14.3 22.1-26.8 22.9-27.3l0.7 1.1c-0.2 0.1-19 12.8-22.2 26.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1269.5 628.1l-1.4-0.1c0-0.2 1.4-16.1-9.3-28.6l1-0.8c11.1 12.9 9.7 29.4 9.7 29.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1286.4 633.5l-1.2-0.5c6.2-13.3-3.6-35.2-3.7-35.4l1.2-0.6c0.4 1 10.2 22.7 3.7 36.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1250.9 658.8l-1.4-0.2c4.4-19.5 26.8-28.2 27.1-28.2l0.4 1.2c-0.2 0.1-22 8.5-26.1 27.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1269.5 667l-1.3-0.1c0.6-19.4 24.2-31.3 24.4-31.5l0.6 1.2c-0.2 0.2-23 11.7-23.7 30.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1284.3 670.3c-0.2-20.8 21.3-29.7 21.5-29.8l0.5 1.3c-0.2 0-20.8 8.6-20.6 28.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1297.3 637.4l-1.2-0.6c0.1-0.1 6.7-13.6 2.4-28.2l1.3-0.4c4.5 15.1-2.4 29.1-2.5 29.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1314.1 644.4l-1.3-0.5c5.8-14.6-1.6-29.9-1.6-30.1l1.2-0.6c0 0.2 7.6 16.1 1.7 31.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1300.7 677.8l-1.3-0.2c3.1-21.9 20.8-32.1 21-32.2l0.7 1.2c-0.2 0.1-17.4 10-20.4 31.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1318.8 682.9c-2.9-24.8 14.2-34.6 14.4-34.8l0.7 1.2c-0.2 0.1-16.5 9.6-13.7 33.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1344.5 686.4c-15.1-11.1-9.4-36-9.3-36.2l1.3 0.3c-0.1 0.2-5.6 24.3 8.8 34.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1365.8 673.2c-27.6 0-31.7-22.5-31.8-22.8l1.4-0.2c0.1 0.9 4.1 22.5 32.1 21.6v1.4q-0.8 0-1.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1372.7 667.1c-23.2 0-41.1-16.9-41.2-17.2l0.6-0.2h0.7-0.7l0.6-0.4c0.1 0.2 21.4 20.3 47.7 15.8l0.2 1.4q-4 0.6-7.9 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1326.2 648.8l-1.2-0.5c0-0.2 4.5-11.6-3.8-25.5l1.1-0.7c8.7 14.5 4.1 26.2 3.9 26.7z"
  })))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1339.3 652.6c-10.2-1.5-23-6.2-37.4-11.6-16.4-6.1-35-13.1-54.6-17.1-27.2-5.5-38.4 3.1-42.9 9.5q-0.7 0.3-1.3 0.7 1.9-2 2.5-5.9c6.4-6.1 18.8-11.6 42.2-6.9 19.8 4 38.5 11 55.1 17.2 11.6 4.3 22.3 8.3 31.1 10.4 2.7 2.2 4.2 3.2 5.3 3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1394.5 703.5q30.9-19.7 62.4-26.9c31.4-7.2 44-5.6 44 10 0 15.6-13.1 21.4-11.1 27.5q2 6.1 6.9 8.5-6.3-4.8-15.2 1.5c-8.9 6.4-25.3 18.3-66.7 18.6-41.4 0.4-41.8-2.2-50.4-13.3q-8.6-11.1-8.3-32 22 0.8 38.4 6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m1495.8 722.1c-1.9-1-7.3-3-14.3 2-8.9 6.4-25.3 18.3-66.7 18.6-41.4 0.4-41.8-2.2-50.4-13.3q-8.6-11.1-8.3-32 7.4 0.3 16.9 1.6c1.1 5.9 3.2 12.3 6.8 17.1 8.6 11.1 9 13.6 50.4 13.3 32.8-0.3 49.9-7.8 60-14.1 1.6 3.8 4.3 5.9 5.6 6.8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m1495.8 722.1q0.5 0.4 0.9 0.5-0.3-0.2-0.9-0.5z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1394.5 703.5l1.6-1.4q57.4 1.7 90.6 15.1-50.4-11.9-92.2-13.7z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1350.2 707.7v-1.4c8.4-0.1 36.2-5.2 44-7.4l0.5 1.3c-8 2.2-35.9 7.4-44.5 7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1357.6 720.8l-0.4-1.3c13.8-3.2 39-10.8 49.5-16.8l0.8 1.1c-10.6 6.1-36.1 13.7-49.9 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1380.3 742.7l-0.7-1.3c13.2-5.7 29.2-25.6 31.8-34.5 0.4-1.1 0.6-2.2 0.1-2.9l1.3-0.7c0.7 1.2 0.4 2.6 0 3.9-2.8 9.4-18.8 29.5-32.5 35.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1404.7 748.1l-1.1-0.9c5.2-5.8 14.6-25.1 17-32.1 0.9-2.7 1.9-6.7 0.1-9.7l1.3-0.7c2.1 3.5 1 7.8 0 10.8-2.5 7.2-11.8 26.5-17.3 32.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1434.6 746.9l-1.4-0.4c2.7-8.5 1.1-33.4-4.7-40.5l1.2-0.8c6.1 7.5 7.7 32.8 4.9 41.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1472.8 742.7c-3.7-10.5-21.7-30-32-34.8l0.7-1.2c10.5 4.9 28.9 24.8 32.7 35.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1412.3 704.7l-1.2-0.7c4.2-6 16.7-21 22.9-25.9l0.9 1c-6 4.8-18.6 19.9-22.6 25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1424.4 705.4l-1-1c9.9-9.5 37.5-30.1 52.6-34.8l0.5 1.3c-13.7 4.3-41 23.9-52.1 34.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1438.3 707l-0.9-1.1c14.7-10.3 52.3-25.9 69.6-30l0.4 1.3c-17.2 4.1-54.5 19.6-69.1 29.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m1456.6 710.4l-0.6-1.2c13.4-6.5 40-12.9 54-14.2l0.1 1.4c-13.5 1.2-40.4 7.7-53.5 14z"
  }))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1309.4 691.7q5.5-19.6 36.1-26.3 30.6-6.6 51.8 1.5 7.1 32.7-13.1 50.4c-20.2 17.8-33.8 10.9-57.3 6.7-23.4-4.2-33.4 15.4-45.4 6.2-12-9.2-4.1-40.8 27.9-38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m1396.8 695.5c-1.9 7.7-5.6 15.7-12.6 21.8-20.2 17.8-33.8 10.9-57.3 6.7-23.4-4.2-33.4 15.4-45.4 6.2-6.5-5-7.1-16.4-1.4-25.6-0.8 6.2 1 12.1 5.1 15.3 12 9.2 22-10.5 45.5-6.3 23.4 4.3 37.1 11.1 57.2-6.6 3.9-3.4 6.8-7.4 8.9-11.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1310.8 686.8l0.5-2.6c30.4 5.4 50.4 43.7 60 62.1l-2.4 1.3c-9.4-18.1-29-55.6-58.1-60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1358.7 727.9c33.7-29.1 29.2-71.3 29.1-71.7l1.4-0.1c0 0.4 4.6 43.2-29.6 72.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1351.3 717.4c24.5-18.2 23.6-64.5 23.6-64.9l1.3-0.1c0 0.5 0.9 47.5-24.1 66.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1347.9 711.5c9.3-12.5 12.8-56.8 12.8-57.2l1.4 0.1c-0.2 1.8-3.6 45.1-13.2 57.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1340.4 703.9c0-19.4 10.8-47.9 10.9-48.2l1.3 0.5c-0.1 0.3-10.9 28.6-10.9 47.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1331.9 696.5c-0.7-21.9 8.3-34.8 8.3-34.9l1.1 0.8c0 0.1-8.7 12.6-8 34.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1321.8 689.7c-2-15.4 4.2-25.9 4.5-26.4l1.2 0.7c-0.1 0.1-6.3 10.7-4.3 25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1277.3 701.3l-0.8-1c13.3-10.2 47.7-9.5 49.2-9.5l-0.1 1.3c-0.3 0-35.4-0.6-48.3 9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1261.7 715.7l-1-0.9c20.3-22.2 73.5-16 75.8-15.8l-0.1 1.4c-0.6-0.1-54.9-6.4-74.7 15.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1264 719.3l-0.6-1.1c32.6-19.3 82.3-10.3 82.8-10.2l-0.3 1.4c-0.4-0.1-49.7-9.1-81.9 9.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m1255.4 736.1l-0.9-1c37.4-32.9 100.7-14.4 101.3-14.2l-0.3 1.3c-0.7-0.2-63.3-18.5-100.1 13.9z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m1311 694.3q-7.4-3.5-18.3-0.4 14.4-5.9 23.7-13.3-7.6 6.4-5.4 13.7z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m1384 734.8c5.8-1.2 21.6-0.3 18.4 12.2-3.1 12.5-45.9 46.9-56.8 47.8q-10.9 1-10.4 10.4-1.6-3.5-4.2-7.9c-2.6-4.3-9.6-7.1-20.8-20.7-11.3-13.5-21-42.7 4-46.9q25.1-4.1 43.5 17.3 20.4-11 26.3-12.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1302.2 771.7l-0.7-0.8c4.8-4.3 12.4-7.3 20.2-7.8 7.8-0.5 16 1.3 21.9 5l-0.5 0.9c-5.7-3.5-13.7-5.3-21.3-4.8-7.6 0.5-15 3.3-19.6 7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1387.1 784.3c-17.3-17.7-46.8-6-47.1-5.9l-0.4-1c0.3-0.1 30.5-12.1 48.3 6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1399.9 767.5c-17.2-20.1-56.4-0.7-56.8-0.5l-0.5-0.9c0.4-0.2 40.4-20.1 58.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1336.2 807.4l-2.2-0.2c6.5-64.5 28.7-66 29.6-66l0.1 2.1-0.1-1 0.1 1c-0.2 0-21.3 1.8-27.5 64.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1309.9 783.5l-0.8-0.8c14.1-14.5 30.8-5.4 31-5.3l-0.6 1c-0.1-0.1-16.2-8.8-29.6 5.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1346.5 759.2c-0.2-0.1-26.1-14.6-49.9-6.3l-0.3-1c24.2-8.5 50.5 6.2 50.8 6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1352.2 750.3c-0.2-0.2-22.5-20.1-56.3-12l-0.2-1c34.3-8.3 57 12 57.2 12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m1349.5 753.6l-0.3-1c2.1-0.8 52.3-19.3 69.1-4l-0.7 0.8c-16.3-14.9-67.5 4-68.1 4.2z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m1396.3 756.8q2.9-19-39.5-9.2c-24.9-14.2-47.7-6.8-58.2-1.8 0.5-7.8 4.9-14.3 15.6-16.1q25.1-4.1 43.5 17.3 20.4-11 26.3-12.2c5.8-1.2 21.6-0.3 18.4 12.2-0.6 2.5-2.9 5.9-6.1 9.8z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m1385.4 755.4c-2.7 7.7-34 29.9-32.9 21.7q1.1-8.2 24-24.8c5.5-4.2 11.7-4.5 8.9 3.1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m1354.5 781.7q-11.5 0.7-11.8 5.5c-0.3 4.8 22.6-6.3 11.8-5.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m1307.4 755.5q-1.5 17.9 8.5 24.8c10 6.9-7.8-38.8-8.5-24.8z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1450.5 557.9c-8.6 12.5-24.1-3.2-45.1 8.1-21.1 11.3-31.9 22-56.6 11.4q-24.6-10.6-28-43.9 17.6-14.2 48.8-17.4 31.1-3.2 42.4 13.8c29.8-12.1 47 15.5 38.5 28z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1372.7 601.4l-2.6-0.4c3.4-20.5 10.6-63.1 37.8-77.7l1.3 2.4c-26.1 14-33.1 55.7-36.5 75.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1375.8 580.8c-41.7-17.5-50.6-59.7-50.7-60.1l1.4-0.3c0.1 0.4 8.8 41.9 49.8 59.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1379.7 568.6c-29.5-9.9-43.2-54.9-43.4-55.3l1.3-0.4c0.2 0.4 13.7 44.7 42.5 54.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1380.8 561.7c-13.1-9.2-29.7-49.3-30.4-51l1.2-0.5c0.2 0.4 17.2 41.4 30 50.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1385.1 551.5c-6-18.2-24.9-41.7-25.1-42l1-0.8c0.2 0.2 19.3 24 25.4 42.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1390.8 541.8c-6-20.6-18.1-29.8-18.2-29.9l0.8-1.1c0.1 0.1 12.6 9.6 18.7 30.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1398.3 532.1c-2.8-14.7-11.9-22.8-12-22.9l0.9-1c0.4 0.3 9.5 8.4 12.4 23.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1396.7 535.3l-0.4-1.3c1.4-0.4 33.9-11.7 49.7-6.1l-0.5 1.2c-15.3-5.3-48.4 6.1-48.8 6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1389.1 546.5l-0.6-1.2c2.1-1 50.8-23.3 77-8.6l-0.7 1.2c-25.5-14.4-75.2 8.4-75.7 8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1382.8 558l-0.7-1.2c0.4-0.2 44.9-24.2 81.9-16l-0.3 1.3c-36.5-8.1-80.5 15.7-80.9 15.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m1377.7 573.2l-0.8-1.1c0.6-0.4 55-37.6 100.8-18l-0.5 1.2c-45.1-19.3-99 17.5-99.5 17.9z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m1401.9 521.5q11.2 4.2 26.7 5.3-11.3 0.4-17.3 6-0.2-7.5-9.4-11.3z"
  })))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m578.6 755.4h-278.7v-20.6h278.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m527.7 751.2c0 126.7 0 121.2 0 247.9 0 4.2-6.5 4.2-6.5 0 0-126.7 0-121.2 0-247.9 0-4.2 6.5-4.2 6.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m470.9 751.2c0 126.7 0 121.2 0 247.9 0 4.2-6.5 4.2-6.5 0 0-126.7 0-121.2 0-247.9 0-4.2 6.5-4.2 6.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m418 751.2c0 126.7 0 121.2 0 247.9 0 4.2-6.5 4.2-6.5 0 0-126.7 0-121.2 0-247.9 0-4.2 6.5-4.2 6.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m362.4 746c0 128 0 123.8 0 251.8 0 4.2-6.5 4.2-6.5 0 0-128 0-123.8 0-251.8 0-4.2 6.5-4.2 6.5 0z"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m472 372.9h-48.1v-109h48.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m472.1 295.9c0 17.9-10.8 32.5-24.1 32.5-13.3 0-24.1-14.6-24.1-32.5v-18.5c0-18 10.8-32.5 24.1-32.5 13.3 0 24.1 14.5 24.1 32.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m421.3 282.5c-20.1 2.4-25-15.5-16.4-18.2q8.6-2.8 12.8 6.3 23.6 9.5 3.6 11.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m410.7 267.9c-1.5-0.7-3.6-1.3-4.9 0.2-1.1 1.2-0.8 2.7-0.2 4 0.3 0.6-0.6 1.1-0.9 0.5-0.8-1.6-1.2-3.9 0.4-5.2 1.8-1.7 4-1.4 6.1-0.4 0.6 0.3 0.1 1.1-0.5 0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m476.9 270.6q4.2-9.1 12.8-6.3c8.6 2.7 3.7 20.6-16.4 18.2q-20-2.4 3.6-11.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m483.4 267c1.9-0.9 4.5-1.4 6.1 0.4 1.4 1.5 1.2 3.5 0.4 5.2-0.3 0.6-1.2 0.1-0.9-0.5 0.6-1.2 1-3-0.2-4-1.5-1.3-3.3-1-4.9-0.2-0.6 0.2-1.1-0.6-0.5-0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m455.6 223.5q25 1.3 25.1 19v41.7q-2.4 37-30.2 38.1-33.3 0.4-35-39.8v-49.2q6.7-11.6 40.1-9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m404.5 251.8c-11.6-13.3 0.6-22.6 5.4-25.5 4.9-2.8-2.7-13.8 7.7-22.8 10.4-9 18.3-0.4 27.2 5.4 8.9 5.9 17.4-12.7 36.4-4.1 19 8.6 11 20.1 10.1 24.9q-0.9 4.7 0.4 4.5c12.7 9.9 0.2 22.2-6.3 27.9q-6.5 5.7-4.7 11-6.5-7-3.5-23.3c-19.5 8.5-42.2-10.7-47.7-15.4q-5.4-4.7-14.1 0 6.1 14.8 0.7 38.4c-1.9-10.6-1.4-9.4-11.6-21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m446.2 271.1c-0.3 6.9-5.9 13.3-13.3 13-6.9-0.3-13.7-5.6-13.3-13 0.3-7 5.9-13.4 13.3-13.1 7.4 0.4 13 5.6 13.3 13.1 0 0.7-1 0.6-1 0-0.3-6.4-5.5-12.3-12.3-12-6.3 0.3-12.6 5.1-12.3 12 0.7 15.5 23.9 15.5 24.6 0 0-0.7 1-0.7 1 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m476.6 271.1c-0.3 6.9-5.9 13.3-13.3 13-6.9-0.3-13.6-5.6-13.3-13 0.3-7 5.9-13.4 13.3-13.1 7.4 0.4 13 5.6 13.3 13.1 0.1 0.7-1 0.6-1 0-0.3-6.4-5.5-12.3-12.3-12-6.3 0.3-12.6 5.1-12.3 12 0.7 15.5 23.9 15.5 24.6 0 0-0.7 1.1-0.7 1 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m443.5 263.6q4.4 0 8.8 0c0.7 0 0.7 1 0 1q-4.4 0-8.8 0c-0.6 0-0.6-1 0-1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s50",
    cx: 431.4,
    cy: 263.3,
    rx: 5.5,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m428.2 273.9c1.6-2.6 5.6-2.6 7.3 0 0.3 0.6-0.6 1.1-0.9 0.6-1.2-2-4.3-2-5.5 0-0.4 0.5-1.3 0-0.9-0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m430 272.8q-0.3-0.4-0.3-1c0-1.2 1-2.1 2.2-2.1 1.2 0 2.2 0.9 2.2 2.1 0 0.5-0.2 0.9-0.5 1.3-0.4-0.5-1.1-0.8-1.9-0.8q-1 0.1-1.7 0.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s50",
    cx: 464.8,
    cy: 263.3,
    rx: 5.5,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m461.5 273.9c1.7-2.6 5.7-2.6 7.3 0 0.4 0.6-0.5 1.1-0.9 0.6-1.2-2-4.3-2-5.5 0-0.3 0.5-1.2 0-0.9-0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m463.4 272.8q-0.3-0.4-0.3-1c0-1.2 0.9-2.1 2.1-2.1 1.3 0 2.2 0.9 2.2 2.1 0 0.5-0.1 0.9-0.4 1.3-0.5-0.5-1.1-0.8-1.9-0.8q-1.1 0.1-1.7 0.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m418.4 297c1.1 2.3 3.8 7 8 6.6 5.4-0.5 6.2-5.8 7.5-10.6 1.3-4.7 6.9-8.2 15.7-7.3 8.8-0.9 14.3 2.6 15.7 7.3 1.3 4.8 2 10.1 7.5 10.6 1.4 0.2 2.7-0.3 3.8-1.1q-8.4 19.1-26.1 19.8c-19.8 0.2-28.4-13.8-32.1-25.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m439.2 291.4c0.1-0.9 0.9-1.6 1.8-1.6h17.3c0.9 0 1.6 0.7 1.6 1.6q-0.1 7.3-10.5 7-10.3-0.3-10.2-7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m412.1 228.1q9.9-8.6 20.8 12.2 10.6 20.3 35.5 15.5c-17.9 4.3-32.4-5.9-37-15.3q-4.5-9.4-15-9.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m412.1 223.1q9.9-8.6 20.8 12.2 10.6 20.3 35.5 15.5c-17.9 4.3-32.4-5.9-37-15.3q-4.5-9.4-15-9.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m452.1 303.5c0 1.4-1.1 2.5-2.5 2.5-1.3 0-2.5-1.1-2.5-2.5v-6.4c0-1.4 1.2-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m454.4 291.4c-2.2 3.4-7.4 3.4-9.6 0-0.3-0.6 0.5-1.1 0.9-0.5 1.7 2.8 6.1 2.7 7.8 0 0.3-0.6 1.2-0.1 0.9 0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m445.2 297.8q1.7 0.6 1.9-0.8 1 0.1 1 0.1 0 0.1-0.3 1.8-0.3 0.3-0.7 0.2c-0.3 0-1.2-0.1-1.3-0.3q-0.1-0.1-0.6-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m453.5 299c-0.1 0.1-1 0.2-1.4 0.3q-0.3 0-0.6-0.3-0.3-1.7-0.3-1.7 0-0.1 0.9-0.1 0.3 1.4 2 0.7-0.5 0.9-0.6 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m416.5 261.6l1.4-0.7q-1.2 16.6-0.3 27.3 0.8 10.7 4.8 14.2l-2.8-2.1q-3.3-6.5-4.1-17.8v-12.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m474.9 303.9l-0.5-0.4q6-2.8 4.8-34.5l1.5 4.1v11.1q0 11.7-4.1 18.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m410.8 946.9l-5.6 54.9h-25.2l-6.3-54.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m714.5 895.9l25.3 83.2h-28.8l-43.5-83.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m717.6 905.9l-40.9 7.7-4-7.7 43.7-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m820.8 988.8q3.8 1.9 5.8 7.2h-107l-8.6-16.9q19.1-1.4 25.5-10.8 80.4 18.5 84.3 20.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m421.8 334.6q0.4 0 8.2 10.6l15.4 17.8 6.3-2.2 22-11.7 30.6 28.9v262.8h-124.6l32.9-303.1q8.8-3.1 9.2-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m305 671.6l15.4-18.7 29.1-19.9 252.3 1.2q29.9 2.1 34.2 30.8l99.8 274.4-54.1 7.5-127.2-212.2q-142.2 1.8-202.9 0-60.7-1.8-58.2-41.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m424.2 321.9l21.2 41.1-17.4 36.6-15.4-61.9q0.4-8.3 11.6-15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m473.7 349.1l-15.1 50.5-13.2-36.6 26.4-30.3q4.8 8.3 1.9 16.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m474.7 347.6q63.2-9.1 108.1 88.9 44.9 98 79.8 196h-69.3-110.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m368 623.4q-61.2 31.9-67.4 136.9-36.1-96.1-34.9-108.6 1.3-12.4 21.2-28.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m330 708.1c4.1-84.1 62.3-103 93.9-29q31.6 74-13.3 289.4h-37.4c-25.8-55.7-47.4-176.3-43.2-260.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m445.4 363l6 16.7-6 12.5 7.4 31.3 15.3 217.3-27.4 39.6-28.1-34.9 16.4-220.8 11.6-32.3-3.1-12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m391.5 577l52.8 26-3.5 26.6h-222.8q48.8-150.6 95.3-231.1 46.6-80.4 99.3-60.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m391.3 577.3l-72.8-42.1 0.4-0.7 72.8 42.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m432 628.2l-0.8-0.1 3.6-28.9 0.8 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m439.2 610.5c-1.6 0-2.9-1.3-2.9-3 0-1.6 1.3-2.9 2.9-2.9 1.7 0 3 1.3 3 2.9 0 1.7-1.3 3-3 3zm0-5.1c-1.1 0-2.1 1-2.1 2.1 0 1.2 1 2.2 2.1 2.2 1.2 0 2.2-1 2.2-2.2 0-1.1-1-2.1-2.2-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m537.5 516.4l-10.8 13.9q-24.6-18.3-16.7-25.6c7.9-7.3 19.7 1.8 27.5 11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m529.9 544.2l-0.7-0.4 12.9-22.9 0.7 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m537.9 523.2c-1 0-1.8-0.8-1.8-1.8 0-1 0.8-1.8 1.8-1.8 1 0 1.8 0.8 1.8 1.8 0 1-0.8 1.8-1.8 1.8zm0-2.8c-0.5 0-0.9 0.5-0.9 1 0 0.5 0.4 1 0.9 1 0.6 0 1-0.5 1-1 0-0.5-0.4-1-1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m616.9 587.7l-68.8-64.6 0.6-0.6 68.7 64.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m395.4 532.5l-27.4-97 11.7-6.1-7.6-17.8 40.5-73.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m510.7 421.6l-10.5 17.3 14.4 4.3-34.6 87.1-5.3-182.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m503.5 471.5q64.9 124.2 113.6 151.9-68.4 14.5-102.5 10.8l-78.3-129.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m465 535.4c-1.1-6.3 2-9.2 8.1-8.5 3 0.4 7.7 2.9 10.5 1.8 4.6-1.8 5.6-8.1 7.2-12.2 0.2-0.6 1.2-0.3 1 0.3-2 5.1-3.6 13.6-10.6 13.1-5.9-0.5-17.3-6.2-15.2 5.2 0.1 0.7-0.9 0.9-1 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m476.7 547c7.4-2.6 14.8-5.2 22.1-8 6.8-2.6 14.7-4.7 20.5-9.2 0.5-0.4 1.1 0.5 0.5 0.9-5.5 4.3-12.8 6.3-19.2 8.8-7.8 3-15.7 5.7-23.6 8.5-0.6 0.2-0.9-0.8-0.3-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m487.6 554.8c0.3 1.2 0.7 2.8 1.7 3.6 0.6 0.4 0.1 1.3-0.5 0.9-1.3-1-1.9-2.7-2.2-4.2-0.1-0.7 0.9-1 1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m495.3 555.5c0.9 1.3 1.7 2.6 2.7 3.8q-0.3 0-0.7 0c3.6-2.9 5.3-7.7 7.1-11.8 0.3-0.6 1.2-0.1 0.9 0.5-1.8 4.2-3.6 9-7.3 12-0.2 0.2-0.5 0.2-0.7 0-1.1-1.2-2-2.6-2.9-4-0.3-0.5 0.6-1.1 0.9-0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m485.5 578.9c8.6-5 17.7-9.2 26.4-13.9 7.3-4 14.1-9.2 21.9-12 0.7-0.2 1 0.8 0.3 1-8.6 3.1-16.3 9.1-24.4 13.3-7.9 4.2-15.9 8.1-23.7 12.5-0.6 0.3-1.1-0.6-0.5-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m496.8 582.5c0.6 1.5 1.2 3.1 2 4.5 1 1.9 1 1.7 1.9-0.9 0.9-2.5 1.4-4.9 2-7.5 0.1-0.3 0.6-0.5 0.9-0.2 2.4 2.5 3.1 5.9 5.1 8.7q-0.5 0.1-1 0.3c0.3-3.1-0.2-6-0.8-9-0.1-0.5 0.3-0.9 0.7-0.6 3.4 1.9 4.2 5.2 6.7 7.9 0.8 0.8 1.6 2.1 1.9 0.3 0.2-1.4 0.4-2.8 0.4-4.3 0-2.4-0.1-4.8-1.1-7.1-0.2-0.6 0.6-1.1 0.9-0.5 2.2 3.5 1.8 0.4 3.2-1.7 0.7-0.9 1.8-0.8 2.7-0.8 2.7 0.1 3.9 4.3 4.2 6.3q-0.6 0-1.1 0c0.9-10 8.5-11.4 16.8-14 0.6-0.2 0.9 0.8 0.2 1-7.5 2.4-15.2 3.5-15.9 13-0.1 0.7-1 0.7-1.1 0-0.3-2.7-4-8-5.8-3.1-0.4 1-0.7 1.7-1.2 2.6-0.3 0.3-0.7 0.3-0.9 0-0.7-0.9-1.4-1.8-2-2.8q0.5-0.3 0.9-0.5c1.8 4.3 1.6 9.5 0.3 14-0.1 0.3-0.4 0.4-0.7 0.3-4-2.4-4.9-7.5-8.9-9.7q0.4-0.3 0.8-0.6c0.6 3.1 1.2 6 0.8 9.3 0 0.5-0.6 0.7-0.9 0.2-1.1-1.5-1.7-3.2-2.6-4.9-0.5-1.2-1.4-3.9-2.1-1.3-0.7 3-1.5 5.8-3 8.4-0.2 0.4-0.7 0.4-0.9 0-1.4-2.2-2.5-4.6-3.4-7-0.3-0.6 0.7-0.9 1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m507.9 605.2c5.5-3.7 11.5-6.4 17.5-9.1 0.6-0.3 1.1 0.6 0.5 0.9-6 2.7-12 5.4-17.4 9.1-0.6 0.4-1.1-0.5-0.6-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m539.3 603c5.1-3.4 9.7-7.5 15.6-9.5 0.6-0.2 0.9 0.8 0.3 1-5.8 1.9-10.4 6.1-15.4 9.4-0.6 0.4-1.1-0.5-0.5-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m544 615.5c5.9-2.5 11.9-4.6 18-6.6 3.4-1.2 6.7-2.5 10.1-3.3 3-0.7 6-1.4 8.7-2.9 0.6-0.3 1.2 0.6 0.6 0.9-5 2.6-10.8 3.5-16.1 5.2-7 2.4-14 4.7-20.8 7.6-0.6 0.2-1.1-0.7-0.5-0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m444.3 603l16.8 5.2q-1.5-6.6 10-15.1 11.4-8.6 19.3-5 0.6 7.5 12.2 11.3c11.6 3.9 33.8-4.3 34.7-1.1 1 3.2-1.2 8.1-8.4 11.9q3.2-1.2 3.6 2.5c0.3 3.6-2.8 11.5-21 15.5q-18.1 4-70.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m374.9 1001.8h34.6l1.3 20-37.1-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m363.8 1029.2q5.5-17.1 32.1-13.3 26.6 3.9 18.3 15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m329.9 541.1l-0.9-0.1 8.3-65.7 0.8 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m342.8 747.3c-2.4-60.1 20.4-88.9 20.7-89.2l0.6 0.5c-0.2 0.3-22.9 28.9-20.4 88.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m364.2 760.3h-0.8v-51.2h0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m406.9 885.7l-0.8-0.1c4.9-81.9 8.9-163.8 8.9-164.6h0.9c-0.1 0.8-4.1 82.7-9 164.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m401.3 940h-0.8v-26.4h0.8z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m1008.5 573.7q-63.6-0.6-66.8-4.3c-3.3-3.7-12.9 6-22.6 9.9-9.7 3.8-11.9-19.7-1.2-30.6q10.7-10.9 37.8 1l43.3-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m1142.5 580.6l-132.2-1.5-12.9-37.8 124-22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m1009.4 576.5l-3.6 0.2-11.9-34.4 4 0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m1067.5 874.7l30.4 66-16.4 13-42.9-41.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m884.4 916.8l-43.5 83.2h-28.8l25.3-83.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m1165.2 368.2c-0.4 4.7-6.8 24.3-7.6 28.1-0.8 3.7-47.3 31.1-44.4-10.8q2.9-41.9-13.9-66.3-4.5 4.1-16.3 1.9-11.8-2.3-21.3-19l-14.4 3.7-2.3-71.7h41.7l24.6 10.5-7.9 8.7q13.1 11.8 22 37.6 8.8 25.8 51.7 39.7-11.4 32.8-11.9 37.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m1051 766.2q40-20.4 66.3-30.5 26.2-10.1 56.5-22.6 22.2-11.3 31.8-7.9c9.6 3.4-14.7 69.2-45.4 73.1-30.6 4-66 2-109.2-12.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1212.2 769.7l32.5 259.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1216.1 769.7q16.3 129.9 32.5 259.7c0.7 5-7.2 4.9-7.8 0q-16.3-129.9-32.5-259.7c-0.7-5 7.2-5 7.8 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1185.8 775.5l-123.9 220.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1189.2 777.5q-61.9 110.3-123.9 220.6c-2.5 4.4-9.3 0.4-6.8-4q62-110.3 123.9-220.6c2.5-4.4 9.3-0.4 6.8 4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1194.7 778.3l-25.7 166.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1198.5 779.4q-12.8 83.1-25.7 166.2c-0.8 5-8.4 2.8-7.6-2.2q12.9-83 25.7-166.1c0.8-5 8.4-2.9 7.6 2.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1228.4 769.9l124.8 216.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1231.9 768q62.3 108 124.7 216.1c2.5 4.4-4.3 8.3-6.8 3.9q-62.4-108-124.8-216.1c-2.5-4.4 4.3-8.3 6.9-3.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m1208.3 769.7c-0.7-5 7.2-5 7.8 0q2.7 21.2 5.3 42.4l-7.8-0.1q-2.7-21.1-5.3-42.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m1156 820.5q13.2-23.5 26.4-47c2.5-4.4 9.3-0.4 6.8 4q-12.1 21.5-24.2 43.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m1184.2 820.6q3.4-21.7 6.7-43.3c0.8-5 8.4-2.9 7.6 2.1q-3.2 20.6-6.4 41.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m1225 771.9c-2.5-4.4 4.3-8.3 6.9-3.9q15.2 26.4 30.5 52.9h-9.1q-14.1-24.5-28.3-49z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m1086.3 709.1q-33.6-11.5-40.3 11.7-6.6 23.2 40.3 169.7l-50.2 26.3q-133.9-126.1-160.2-207.7-26.3-81.6 146-79.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m1117.6 363.5l21.7-2.7h11.5l3.4 4.1q15.7 32.5 12.5 35.8c-3.3 3.3 3.2 39.9 4.9 43.2 1.7 3.4 15.8 52.4 20 54.9 4.1 2.5 0 94.8 0 98.1 0 3.4-32.5 133.1-84.9 71.6q-52.4-61.6 6.9-291.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m1178.5 605.8q46.1 18.9 51 97.6c6.7 106.4-296.6 41.3-235.6 56.6q5.6 1.3-97.6 156.8h-72.6q31.1-212.3 84.3-259.4 53.2-47.1 242.8-41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m1026.6 741.5c-41.8-9.9-56.2-36.5-56.3-36.8l0.7-0.4c0.1 0.3 14.4 26.6 55.8 36.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m946.6 798.9l-0.7-0.3c23.4-48.6 3.5-83 3.3-83.3l0.7-0.5c0.2 0.4 20.4 35.2-3.3 84.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m979.4 751.8l-16.3-33.8 0.7-0.4 16.3 33.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m1161.3 745.9l-131.4-27.7 0.1-0.8 131.4 27.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m889.2 879.6q-0.1 0-0.1 0l-0.4-0.4h0.4l-0.3-0.2c0.7-1.7 20.2-74.7 30.4-113.1l0.8 0.3q-7.5 28.2-15.1 56.5c-4.4 16.5-7.9 29.5-10.4 38.9-3.5 12.7-4.5 16.5-5 17.6-0.1 0.3-0.2 0.4-0.3 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m1139.3 627.4l-47.7 79.2c-64.6-55.6-157-64.9-157-64.9 54.6-22.6 150.1-25.5 193.6-25.6q5.9 6 11.1 11.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m1152.2 313.8q84.6 18.7 109 134 24.3 115.3-25 261.3-79.8 26.3-144.1 0-18.3-102.7 10.5-217.5 28.8-114.8 42.7-147.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m1332.2 608.7q-7.5 29.1-13.6 110c-2.4 20.8-6.6 34.7-35.4 55.5-38 27.5-101.5 26-127 20.7-25.6-5.3-113.3-24.6-103.8-28.3 9.4-3.6 17.3-15.2 61.4-5.3 44.1 9.9 65.2-7.1 78.1-33.4q13-26.3 38.6-79.9c11.7-23.7 35.7-90.9 63.7-89.1 51.2 3.2 50.1-14.8 53.4-7 3.3 7.8-6.6 23-15.4 56.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1062.2 250.1c-8.5 4.3-20.8 16.4-35.6 6.2-14.9-10.1-6-25.1 5.7-31.7 11.8-6.7 6-15.1 14.7-33.4 8.8-18.4 41.1-16.4 48.4-3.2 7.4 13.3 14.9 12.4 29.2 20.5 14.3 8 10.1 20.2 0.5 38.2-9.6 18 3.5 25.7 2.5 36.7q-1.1 11-17.3 5.8 1.7-17.1-5.6-18.7-7.4-1.6-10.9 12.6-2.6-9.6-11.8-11.4-9.3-1.7-8.6-16.4c2.1-5.8-2.6-9.6-11.2-5.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1109.3 343.2q-4.2-15.5-10-24 7.3-2.9 8.7-12.8 6.8 18.8 1.3 36.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m1068.5 185.4c-13.5-0.4-14.5 16.7-18.7 25.9-0.3 0.6-1.2 0.1-0.9-0.5 4.4-9.6 5.5-26.8 19.6-26.4 0.7 0 0.7 1 0 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m1030.4 233.3c-5.6 2.8-6.1 11.6-2.7 16.1 3.1 4.3 7.9 4.3 12.7 4.3 0.6 0 0.6 1 0 1-6.1 0-12.4-0.5-14.8-7.1-1.9-5.1-1.2-12.5 4.2-15.2 0.6-0.3 1.2 0.6 0.6 0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m1093.7 209.9c-14.2-4.7-24.6 13.8-31.3 23.2-4.5 6.1-12.9 19.8-22 13.4-0.6-0.4-0.1-1.3 0.5-0.9 5 3.5 9.8 0 13.4-3.8 4.7-5.2 8.4-11.1 12.6-16.7 6.2-8.3 15.2-20.2 27.1-16.2 0.6 0.2 0.4 1.2-0.3 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m1100.1 215.8c4 8.6 3 17-1.3 25.3-4.8 9.2-11.5 17.7-11.5 28.6 0 0.7-1 0.7-1 0 0-9 4.4-16.5 8.8-24.1 5.5-9.5 9-18.7 4.1-29.3-0.3-0.6 0.6-1.1 0.9-0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m1105.1 220.5c15.7-1.6 12.3 20.8 10 30.2-0.1 0.7-1.1 0.4-1-0.3 2.2-8.7 5.8-30.4-9-28.8-0.7 0-0.7-1 0-1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m904.4 910.5l-3.9 18.3-84.4-7.5 2.1-10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m835.5 923l43.7 3.9-4.1 7.7-40.8-7.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m815.4 989.2q6.4 9.4 25.5 10.8l-8.6 16.9h-107q1.9-5.2 5.8-7.2 3.9-1.9 84.3-20.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1119.6 939.3l-48.8 80.5h-70.3c6.1-12.6 24.7-13 41.9-15.4q17.2-2.3 32.1-57.2 18.2-14 14.9-24.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m1144 587.4l-0.8-0.2 38.7-166.3 0.8 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m1190.1 661.9l-98.6-24.6 0.2-0.8 97.8 24.4 28.5-118.9 0.8 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m988.4 624.2h-200.2v-15.6h200.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m982.8 608.6h-180.2v-23.3h180.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m899.3 585.3l61.9-62.4q4.4-3.4 2.2 2.3-57.4 58.7-57.4 58.3 0-0.4-6.7 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m1000.3 603.7q-60.9-18.3-63-22.7c-2.1-4.4-14 2.2-24.4 3.2-10.4 1-6-22.2 7.4-29.7q13.3-7.4 35.9 11.5l42.6 8.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m1127.1 647.6l-126.6-38.2-1.8-39.9 125.2 13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m1000.4 606.6l-3.6-0.8-1.8-36.3 3.7 1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1073.3 305.2c2.5 3.6 7.1 1.3 7.3-2.7 0-0.5 0.7-0.4 0.7 0-0.2 4.6-5.6 7.3-8.6 3.2-0.2-0.4 0.3-0.8 0.6-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1061.1 272c0.9 3.7 1.2 10.7-4 11.5-5.1 0.9-7.2-5.3-8.1-9.4-0.1-0.6 0.7-0.7 0.9-0.2 0.6 3 2.7 10.1 7 8.8 4.6-1.4 4.2-6.8 3.3-10.5-0.1-0.6 0.8-0.8 0.9-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1060.7 259.4c-3.8-1.6-7.9-1-11.1 1.5-0.9 0.7-1.8-0.8-0.9-1.5 3.6-2.9 8.5-3.4 12.8-1.5 1 0.4 0.2 2-0.8 1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m1059.6 289.9c-7.8 1.7-15.6-3.2-17.4-11-1.8-7.8 3.1-15.6 11-17.4 7.8-1.8 15.6 3.1 17.4 10.9 1.8 7.9-3.2 15.7-11 17.5zm-6-26.4c-6.6 1.6-10.8 8.2-9.3 14.9 1.5 6.7 8.2 10.9 14.8 9.4 6.7-1.5 10.9-8.2 9.4-14.9-1.5-6.7-8.2-10.9-14.9-9.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1082.2 269.5l-13.3 3.5-0.5-2.1 13.3-3.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s72",
    cx: 1081.3,
    cy: 286.5,
    r: 10.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s73",
    d: "m1142.8 312.7q10.7-0.6 11.3 2.9 0.7 3.6-23.4 78.2 0-26.8-17.1-16.6 8.7-35.1 29.2-64.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m1041.1 914.2l35.9-18.8 1.9 4.1-35.1 17.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m465.3 586.3h-100v-18.9h100z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m376.2 586.3h-4.5v-18.9h4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m382.5 586.3h-4.4v-18.9h4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m452 586.3h-4.4v-18.9h4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m458.4 586.3h-4.4v-18.9h4.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s75",
    d: "m365.3 622.1v-13.2h100v13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m365.3 622.1v-13.2h100v13.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m454.1 622.1v-13.2h4.4v13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m449.4 622.1v-13.2h2.8v13.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s74",
    d: "m443.4 607.1h-100v-18.9h100z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 590.1h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 592.1h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 594.2h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 596.2h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 598.3h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 600.3h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 602.4h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 604.4h-97.3v-1.1h97.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s76",
    d: "m443.4 606.5h-97.3v-1.1h97.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s75",
    d: "m445.7 608.9h-104.2v-22.6h104.2v3.7h-97.6v15.3h97.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s75",
    cx: 445.7,
    cy: 588.2,
    rx: 1.9,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "<Path>",
    className: "s75",
    cx: 445.7,
    cy: 607.1,
    rx: 1.9,
    ry: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s77",
    d: "m383.7 596.2v16.7l-5.6-1.3-5.6 5.7v-21.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m346.8 620.7h-81.9l15.7-82h82z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s78",
    d: "m306.2 589.7h2.7l5.7-30h-2.6l0.3-1.8h4.5l-6.1 31.8h2.7l-0.4 1.8h-7.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s78",
    d: "m327.8 560.8l-1.4 7.5q-0.4 1.6-1.8 2.7c0.6 0.7 0.9 1.6 0.7 2.7l-2.7 14.2c-0.4 2-2.3 3.6-4.3 3.6-2 0-3.3-1.6-2.9-3.6l2.7-14.2q0.4-1.6 1.8-2.7c-0.7-0.7-0.9-1.6-0.7-2.7l1.4-7.5c0.4-1.9 2.3-3.6 4.3-3.6 2 0 3.3 1.6 2.9 3.6zm-3.3 7.5l1.5-7.5c0.2-0.9-0.5-1.7-1.4-1.7-1.1 0-2 0.8-2.2 1.7l-1.4 7.5c-0.2 0.9 0.3 1.8 1.4 1.8 1.1 0 2-0.9 2.1-1.8zm-3.7 19.6l2.7-14.2c0.2-1-0.3-1.8-1.4-1.8-1.1 0-2 0.7-2.1 1.8l-2.8 14.2c-0.2 1.1 0.5 1.8 1.5 1.8 0.9 0 1.9-0.7 2.1-1.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s79",
    d: "m360.7 548.6h-82l1.9-9.9h82z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m293 607.5l-0.6 3.2c-0.2 1.1-1.3 2.1-2.5 2.1h-2.3c-1.2 0-1.9-1-1.7-2.1l0.7-3.2h0.9l-0.6 3.2c-0.2 0.7 0.1 1.5 0.8 1.5h2.4c0.6 0 1.3-0.8 1.4-1.5l0.6-3.2c0.2-0.9-0.1-1.2-0.8-1.8-0.7-0.6-1.6-1.4-2.4-2-0.9-0.7-1.1-1.3-1-2.3l0.6-2.7c0.2-1.2 1.3-2.2 2.4-2.2h1.9 0.1c1.1 0 1.8 1 1.6 2.2l-0.6 3.2h-1l0.7-3.2c0.1-0.7-0.2-1.5-0.9-1.5h-1.9c-0.7 0-1.3 0.8-1.4 1.5l-0.5 2.5c-0.2 1.1 0.2 1.4 0.8 1.9 0.6 0.5 1.9 1.6 2.6 2.1 1 0.8 0.9 1.7 0.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m303.8 596.6l-2.7 14.1c-0.2 1.1-1.3 2.1-2.5 2.1h-2.1c-1.1 0-1.9-1-1.6-2.1l2.7-14.1h0.9l-2.7 14.1c-0.1 0.7 0.2 1.5 0.9 1.5h2.1c0.6 0 1.2-0.8 1.4-1.5l2.7-14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m313 596.6l-3.1 16.2h-0.8-0.1-1l-0.7-15.4-3 15.4h-0.9l3.1-16.2h0.7 0.3 0.7l0.9 15.6 3-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m321.4 598.7l-2.3 12c-0.2 1.1-1.3 2.1-2.5 2.1h-4.1l3.1-16.2h4.2c1.4 0 1.9 0.9 1.6 2.1zm-3.2 12l2.3-12c0.1-0.7-0.2-1.4-0.9-1.4h-3.2l-2.9 14.8h3.3c0.7 0 1.3-0.7 1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m326.5 607.4h-3.6l-2 5.4h-0.9l6.2-16.2h1.3l-0.1 16.2h-0.9zm0-0.7l0.1-9.3-3.5 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m337.1 596.6l-4.8 9-1.4 7.2h-0.9l1.4-7.2-1.4-9h0.9l1.2 7.7 4.1-7.7z"
  })))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m362.6 538.7l-3.6 82h-12.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m708.5 605.8h-11.2c-4 0-7.3-3.3-7.3-7.3v-14.6c0-4.1 3.3-7.4 7.3-7.4h11.2c4.1 0 7.4 3.3 7.4 7.4v14.6c0 4-3.3 7.3-7.4 7.3zm-11.2-27.6c-3.1 0-5.7 2.5-5.7 5.7v14.6c0 3.1 2.6 5.7 5.7 5.7h11.2c3.2 0 5.8-2.6 5.8-5.7v-14.6c0-3.2-2.6-5.7-5.8-5.7z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m698.3 571.8h41.8v28.8c0 11.5-9.4 20.9-20.9 20.9-11.6 0-20.9-9.4-20.9-20.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s80",
    d: "m774.4 541.6c0 6.4-5.1 11.7-11.4 12 1 1.8 1.6 3.9 1.6 6.1 0 6.6-5.5 12.1-12.1 12.1h-46.1c0-13.3 10.9-24.2 24.2-24.2h6.5c-1-1.8-1.6-3.8-1.6-6 0-2.6 0.8-5 2.1-6.9-4.4-1.8-7.5-6.1-7.5-11.2 0-6.7 5.4-12.1 12.1-12.1h7.9c6.7 0 12.1 5.4 12.1 12.1 0 2.2-0.6 4.2-1.6 6h1.7c6.6 0 12.1 5.4 12.1 12.1z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s81",
    d: "m709.4 605h-0.8v-26.1h0.8z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s81",
    d: "m704.4 588.7h-0.9v-16.9h0.9z"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m1019.1 620.4c-1.3 15.2-14.1 27.2-29.7 27.2h-719.3c-15.6 0-28.3-12-29.7-27.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s82",
    cx: 858.5,
    cy: 134.4,
    r: 77.9
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s83",
    cx: 849.4,
    cy: 134.3,
    r: 77.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s3",
    cx: 849.4,
    cy: 134.3,
    r: 67.4
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s84",
    d: "m850 130h-0.8v-41.2h0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s84",
    d: "m874.7 170.9l-26.2-35.1 2.2-2.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s85",
    cx: 849.6,
    cy: 133.7,
    r: 4.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s85",
    d: "m848.5 72.2v14.1h-1.1v-13h-0.8v-0.1h0.9v13h0.9v-13.9h-1.8v-0.1zm-1.8 0.3v0.5h0.9v13h0.5v-13.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s85",
    d: "m854.7 77c-0.1 1-1 1.9-2 2.8-0.9 0.9-1.8 1.7-1.8 2.5v2.9h3.8v1.1h-4.8v-4c0-1.3 1.1-2.3 2.1-3.3 0.8-0.7 1.6-1.5 1.6-2v-2.2c0-1.2-0.6-1.6-1.3-1.6-0.9 0-1.3 0.7-1.3 1.7v1.1h-1v-1.2c0-1.9 1.2-2.7 2.3-2.7 1.1 0 2.4 0.7 2.4 2.7zm-0.1-2.2c0-1.9-1.3-2.6-2.3-2.6-1.1 0-2.2 0.8-2.2 2.7v1h0.8v-1c0-1 0.5-1.8 1.4-1.8 0.7 0 1.4 0.4 1.4 1.8v2.1c0 0.5-0.8 1.4-1.6 2.1-1 0.9-2.1 2-2.1 3.2v3.9h4.6v-0.9h-3.8v-3c0-0.8 0.9-1.7 1.8-2.5 1-0.9 2-1.8 2-2.8zm-0.2 2.2c0 0.9-0.9 1.7-1.8 2.6-1 0.9-1.9 1.8-2 2.7 0 0.2 0 2.2 0 3.2h3.8v0.5h-4.3c0-0.3 0-3.4 0-3.7 0.1-1.2 1.1-2.1 2.1-3.1 0.8-0.7 1.7-1.6 1.7-2.2v-2.2c0-1.5-0.8-1.9-1.6-1.9-1 0-1.6 0.8-1.6 2v0.8h-0.5v-0.9c0-1.7 1.1-2.4 2.1-2.4 0.9 0 2.1 0.6 2.1 2.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s85",
    d: "m853.2 189.7v1.5c-0.1 1.7-0.9 3-2.6 3-1.6 0-2.5-1.3-2.5-3v-8.4c0-1.7 1-2.9 2.6-2.9 1.5 0 2.4 1.2 2.4 2.9v0.8h-1v-0.8c0-1.1-0.5-1.9-1.4-1.9-1 0-1.5 0.7-1.6 1.9v4.6c0.4-0.4 1.1-0.7 1.6-0.7 1.5 0 2.5 1.1 2.5 3zm-4.2-2.1v-4.8c0-1.2 0.7-2 1.7-2 1 0 1.5 0.9 1.5 2v0.7h0.8v-0.7c0-1.7-0.8-2.8-2.3-2.8-1.5 0-2.5 1.2-2.5 2.8v8.4c0 1.6 0.8 2.9 2.4 2.9 1.6 0 2.4-1.3 2.5-2.9v-1.5c0-1.8-1-2.9-2.4-2.9-0.6 0-1.2 0.3-1.7 0.8zm3.9 2.1v1.5c-0.1 1.5-0.8 2.7-2.3 2.7-1.4 0-2.2-1.2-2.2-2.7 0-2.1 0-6.6 0-8.4 0-1.5 0.9-2.7 2.3-2.7 1.4 0 2.1 1.1 2.1 2.7v0.5h-0.5v-0.5c0-1.3-0.5-2.2-1.6-2.2-1.1 0-1.8 0.9-1.9 2.2v5.3c0.5-0.7 1.2-1.1 1.9-1.1 1.3 0 2.2 1 2.2 2.7zm-0.5 0c0-1.5-0.6-2.2-1.7-2.2-1.2 0-1.8 1-1.8 2.2 0 0 0 1.1 0 1.5 0 1.2 0.6 2.1 1.7 2.1 1.2 0 1.8-0.9 1.8-2.1zm-0.2 1.5c0 1-0.5 1.9-1.6 1.9-1 0-1.6-0.9-1.6-1.9v-1.5c0-1.1 0.6-2 1.7-2 1 0 1.5 0.6 1.5 2zm-0.1-1.5c0-1.3-0.5-1.9-1.4-1.9-1 0-1.6 0.8-1.6 1.9v1.5c0 1 0.6 1.8 1.5 1.8 1 0 1.5-0.8 1.5-1.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s85",
    d: "m908.3 132.6h0.8c0.9-0.1 1.3-0.9 1.3-1.9v-2.9c0-1.1-0.5-1.6-1.2-1.6-1 0-1.5 0.7-1.5 1.7v1.1h-1v-1.2c0-2.1 1.3-2.7 2.5-2.7 1.2 0 2.3 0.9 2.3 2.7v2.9c0 1.2-0.4 1.8-1 2.4 0.9 0.5 1.1 1.5 1.1 2.6v0.8c0 1.6-0.9 3-2.5 3-1.5 0-2.5-1.2-2.5-3v-1.2h1v1.2c0 1.1 0.5 1.9 1.5 1.9 0.9 0 1.5-0.8 1.5-1.9v-0.8c0-1.1-0.4-2-1.5-2h-0.8zm0.1 1h0.7c1.2 0 1.6 1 1.6 2.1v0.8c0 1.2-0.6 2-1.6 2-1 0-1.6-0.8-1.6-2v-1.1h-0.8v1.1c0 1.7 1 2.9 2.4 2.9 1.5 0 2.4-1.3 2.4-2.9v-0.8c0-1.2-0.3-2.1-1.2-2.6 0.8-0.6 1.1-1.4 1.1-2.4v-2.9c0-1.8-1.1-2.6-2.2-2.6-1.1 0-2.4 0.6-2.4 2.6v1.1h0.8v-1c0-1.1 0.6-1.8 1.6-1.8 0.7 0 1.3 0.6 1.3 1.7v2.9c0 1-0.5 1.9-1.4 2h-0.7zm0.2-0.7h0.5c1-0.1 1.6-1.1 1.6-2.2v-2.9c0-1.3-0.7-1.9-1.5-1.9-1.1 0-1.7 0.8-1.7 2v0.8h-0.5v-0.9c0-1.8 1.2-2.4 2.2-2.4 1.1 0 2 0.7 2 2.4v2.9c0 1.1-0.4 1.9-1.3 2.4 1 0.4 1.4 1.3 1.4 2.6v0.8c0 1.5-0.8 2.7-2.2 2.7-1.3 0-2.3-1.1-2.3-2.7v-0.9h0.5v0.9c0 1.3 0.7 2.2 1.8 2.2 1.1 0 1.8-0.9 1.8-2.2v-0.8c0-1.2-0.5-2.3-1.8-2.3h-0.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s85",
    d: "m793.3 136.8c0 1.7-1 2.9-2.6 2.9-1.6 0-2.5-1.3-2.5-2.9v-0.8h1v0.8c0 1 0.5 1.8 1.5 1.8 1 0 1.6-0.8 1.6-1.8 0 1.1-0.5 2-1.6 2-1.1 0-1.6-0.9-1.6-2v-0.7h-0.8v0.7c0 1.6 0.9 2.9 2.4 2.9 1.5 0 2.5-1.2 2.5-2.9v-7.8c0-1.8-0.7-3.4-2.5-3.4-1.8 0-2.5 1.7-2.5 3.4v-0.1c0-1.7 0.7-3.5 2.5-3.5 1.9 0 2.6 1.7 2.6 3.5zm-5.1-5.9q0 0.5 0.1 0.9-0.1-0.4-0.1-0.8zm4.1 2.6v0.2c-0.3 0.3-0.7 0.6-1.1 0.7 0.5-0.2 0.9-0.5 1.1-0.9zm-1.6 1q0.3 0 0.5-0.1-0.2 0.1-0.5 0.1zm0 0c-1.6 0-2.3-1.3-2.4-2.7 0.1 1.4 0.8 2.7 2.4 2.7zm2.3 2.4c0 1.5-0.9 2.6-2.3 2.6-1.4 0-2.3-1.2-2.3-2.6v-0.5h0.5v0.5c0 1.2 0.6 2.1 1.8 2.1 1.2 0 1.8-0.9 1.8-2.1v-4.1c-0.2 0.8-0.9 1.5-1.8 1.5-1.8 0-2.3-1.8-2.3-3.3 0-0.6 0-1.2 0-2 0-1.5 0.7-3.2 2.3-3.2 1.7 0 2.3 1.5 2.3 3.2zm-0.5-7.8c0-1.3-0.4-2.7-1.8-2.7-1.3 0-1.8 1.4-1.8 2.7 0 1.2 0 0.2 0 2 0 1 0.3 2.7 1.8 2.7 1.3 0 1.8-1.6 1.8-2.8zm-0.2 2c0 1-0.5 2.6-1.6 2.6-1.3 0-1.6-1.6-1.6-2.6v-2c0-1.2 0.5-2.5 1.6-2.5 1.3 0 1.6 1.3 1.6 2.5zm-0.1-1.9c0-1.1-0.3-2.4-1.5-2.4-1.1 0-1.5 1.2-1.5 2.4v2c0 0.9 0.3 2.4 1.5 2.4 1.1 0 1.5-1.4 1.5-2.5z"
  })))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s86",
    d: "m1349.5 169.3v7.8 101.5 7.8h-7.7-104.5-4.8-3v-117.1h3 4.8 104.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s87",
    d: "m1343.3 280.4h-117.1v-117h117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s88",
    d: "m1343.3 171.1h-117.1v-7.7h117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s89",
    d: "m1343.3 280.4h-117.1v-7.8h117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s89",
    d: "m1223.3 280.4v-117h7.8v117z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s88",
    d: "m1335.5 280.4v-117h7.8v117z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s90",
    d: "m1272.6 236.5c-3.6 1.9-9.9-0.3-13.8-0.8-3.4-0.5-8-1.3-10.8-3.1-4-2.5-4.9-5.9-6.9-9.8-2.2-3.9-12.1-20-0.1-17.3 6.8 1.5 12.1 5.3 17.9 8.9 2.4 1.5 4.9 2.1 7.2 3.4 3.1 1.7 2.4 6.2 5.5 8l0.4 0.3c5.9 3.7 5 8.1 0.6 10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1277.6 235c-16.5-3-40.7-27.8-41-28l0.2-0.2c0.3 0.3 25.6 26.1 42 28.1l-0.1 0.2q-0.5 0-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1320.5 243.8c-7.2 5.6-16.1 2.6-23.5 0.7-3.2-0.9-20.1-3.8-12.5-9.9l0.5-0.8c2.8-2.9 3.5-4.2 7.4-5.2 3.6-1.1 5.5-1.9 8.9-3.6 5.4-3 14.9-3.3 21-0.8 8.2 3.4 3.5 15.4-1.8 19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1278.2 214.9l-0.2 0.3c-3.9 5.9-23.1-16.1-23.3-21.2-0.5-10.4 11.1 1.4 14.3 4.5 2.2 1.8 5.5 4.1 7.1 6.7 2 3.2 1.9 6 2.1 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1286.9 216.2c0.7-8.7 9.5-11.4 16.4-13.6 3.3-1.1 16-6.9 14.2 1.6-0.6 3.9-6.3 5.5-9.2 7.2-3.2 2-5.4 4.8-8.3 6.8-4.5 2.9-10.3 3.1-13.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1283.1 201c-3.3-0.6-5.1-1.8-7.8-4.5-1.7-1.7-8.7-7.3-8.5-9.8 0.1-7.4 15.4 11 16.6 12.4l0.2 0.3c0.4 1.6-0.2 1.1-0.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s90",
    d: "m1301.9 197.5c-2.1 2.2-15.2 6.6-14.2 3v-0.1c3.1-2.6 6.8-6.2 10.9-6.9 4.4-0.7 5.6 1 3.3 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1293.7 189.2c-2.7 4.1-5.8 6.9-9.2 4.5l-0.1-0.2c-3.1-3.6-5.1-8.6-2.1-12.3 2.2-2.8 11.1-9.7 14.8-6.2 2.8 3-1.5 11.4-3.4 14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1266.9 247.4c-4.6 3.5-10.8 4.7-16.6 3.4-8.2-2.1-4.9-6 1.4-8 5.8-2.2 11-2.7 17-2.5l0.3 0.1c4.9 1.1 0.1 5.4-2.1 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s92",
    d: "m1289.6 254.3c-3.9-2.1-8.3-4.9-9.7-9.7 1-3.8 16.7 5.5 17.4 9.4 1.4 5.3-5.1 1.9-7.7 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1282.2 218.7c-3.4-1.7-10.5-7.6-25-26.2-0.4-0.6-0.7-0.9-0.8-0.9l0.2-0.2c0.1 0 0.3 0.3 0.8 0.9 14.4 18.6 21.5 24.5 24.9 26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1283.3 217.3c-0.4 0-0.6-0.1-0.6-0.1l0.2-0.3c0 0 2.9 1.4 10.2-3.7 0.1-0.1 15.8-10.1 22.6-10.8v0.2c-6.7 0.8-22.3 10.7-22.5 10.8-5.7 4.1-8.8 4.1-9.9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1284.9 203.1c-2.1-3.2-16.6-16.5-16.7-16.6l0.2-0.2c0.6 0.6 14.6 13.5 16.7 16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1284.9 203.1l-0.2-0.2c0.1-0.2 3.4-2.2 6.6-4 3.2-1.7 7.5-3.8 10.1-4.1v0.3c-4.8 0.6-16.2 7.6-16.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1270.5 257.2l-0.2-0.1c3.3-6 7.4-19.6 7.5-19.7 3.8-11.3 6.8-33.6 6.8-33.8 1.1-15.9 5.8-24.1 5.9-24.1l0.2 0.1c-0.1 0.1-4.7 8.2-5.8 24 0 0.2-3 22.6-6.9 33.9 0 0.1-4.1 13.7-7.5 19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1278.4 236.1l0.1-0.3c0.3 0 33.1 2.1 44.5-6l0.2 0.2c-11.5 8.1-44.4 6.1-44.8 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1247.5 247l-0.1-0.3c0.1 0 10.1-0.8 15.5-3.1 0.4-0.1 10.2-3.3 13.7-2.1l-0.1 0.2c-3.4-1.1-13.4 2.1-13.5 2.2-5.5 2.3-15.4 3.1-15.5 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s91",
    d: "m1295.7 254.9c-0.1-0.1-10.4-10.8-19.5-11.9l0.1-0.3c9.1 1.2 19.5 11.9 19.6 12z"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s93",
    d: "m850 374.7h-38.9v-54h54v38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s94",
    d: "m850 374.7v-15.9h15.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m855.3 335.2h-35.7v-1.2h35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m855.3 341.8h-35.7v-1.2h35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m855.3 348.4h-35.7v-1.2h35.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s95",
    d: "m795.4 364.8l-33.4 19.9-27.6-46.4 46.4-27.6 19.5 32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s96",
    d: "m795.4 364.8l-8.1-13.7 13-7.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m779.8 328.2l-30.7 18.2-0.6-1 30.6-18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m783.2 333.8l-30.7 18.3-0.6-1 30.6-18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m786.5 339.5l-30.6 18.3-0.6-1.1 30.6-18.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s95",
    d: "m782.7 459.9l-32.7-20.9 29-45.5 45.5 29-20.5 32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s96",
    d: "m782.7 459.9l8.6-13.4 12.7 8.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m808.4 429.5l-30.1-19.2 0.7-1 30.1 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m804.9 435.1l-30.1-19.2 0.6-1.1 30.1 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m801.3 440.6l-30.1-19.2 0.7-1 30.1 19.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s97",
    cx: 759.3,
    cy: 330,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s97",
    cx: 838.1,
    cy: 324.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s97",
    cx: 798.4,
    cy: 412.3,
    r: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s98",
    d: "m622.4 92c-7.9 0-14.3-7.8-14.3-17.4 0-9.6 6.4-17.3 14.3-17.3 7.9 0 14.3 7.7 14.3 17.3 0 9.6-6.4 17.4-14.3 17.4zm0-32.9c-6.9 0-12.5 6.9-12.5 15.5 0 8.6 5.6 15.6 12.5 15.6 6.9 0 12.4-7 12.4-15.6 0-8.6-5.5-15.5-12.4-15.5z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s98",
    d: "m687.8 210.8h-136.2v-136.2h136.2z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s98",
    d: "m610.4 159.3h4.5v-49.7h-4.4v-3h7.4v52.7h4.4v3h-11.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s98",
    d: "m637.1 111.4v12.3c0 1.9-0.8 3.5-2 4.6 1.2 1.1 2 2.7 2 4.4v23.7c0 3.3-2.7 5.9-5.9 5.9-3.4 0-6-2.6-6-5.9v-23.7c0-1.7 0.7-3.3 2-4.4-1.3-1.1-2-2.7-2-4.6v-12.3c0-3.2 2.6-6 6-6 3.2 0 5.9 2.6 5.9 6zm-3 12.3v-12.3c0-1.6-1.3-2.9-2.9-2.9-1.7 0-3 1.3-3 2.9v12.3c0 1.6 1.1 3.1 3 3.1 1.6 0 2.9-1.5 2.9-3.1zm0 32.7v-23.7c0-1.6-1.2-2.9-2.9-2.9-1.8 0-3 1.2-3 2.9v23.7c0 1.7 1.3 3 3 3 1.6 0 2.9-1.3 2.9-3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s98",
    d: "m687.8 91.1h-136.2v-16.5h136.2z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s98",
    d: "m594.2 188.8v5.4c0 1.9-1.5 3.5-3.4 3.6h-4c-1.8-0.1-3.3-1.7-3.3-3.6v-5.4h1.5v5.4c0 1.2 0.8 2.4 1.9 2.4h3.9c1.1 0 1.9-1.2 1.9-2.4v-5.4c0-1.4-0.6-1.9-1.9-2.9-1.4-1-3.1-2.2-4.6-3.3-1.8-1.1-2.4-2.2-2.4-3.7v-4.7c0-1.9 1.6-3.5 3.5-3.5h3.1c1.9 0 3.5 1.6 3.5 3.5v5.4h-1.6v-5.4c0-1.1-0.8-2.4-1.9-2.4h-3.1c-1.2 0-1.9 1.3-1.9 2.4v4.3c0 1.8 0.7 2.3 1.9 3.1 1.1 0.8 3.7 2.6 4.9 3.5 2 1.3 2 2.7 2 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s98",
    d: "m608.7 170.8v23.4c0 1.9-1.6 3.6-3.5 3.6h-3.4c-2 0-3.5-1.7-3.5-3.6v-23.4h1.5v23.4c0 1.2 0.8 2.4 2 2.4h3.4c1.2 0 1.9-1.2 1.9-2.4v-23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s98",
    d: "m623.9 170.8v26.9h-1.3-0.2-1.6l-6.1-25.5v25.5h-1.6v-26.9h1.3 0.3 1.2l6.5 25.9v-25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s98",
    d: "m638.6 174.2v20c0 1.9-1.6 3.5-3.5 3.5h-6.9v-26.9h6.9c2.4 0 3.5 1.5 3.5 3.4zm-1.6 20v-20c0-1.1-0.7-2.3-1.9-2.3h-5.3v24.6h5.3c1.2 0 1.9-1.1 1.9-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s98",
    d: "m649.8 188.8h-6l-1.6 8.8h-1.4l5-26.9h2.2l5 26.9h-1.6zm-0.1-1.1l-2.8-15.4-2.8 15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s98",
    d: "m664 170.8l-5.2 15v11.9h-1.5v-11.9l-5.2-15h1.6l4.4 12.8 4.4-12.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m616 85.6c-7.8 0-14.2-7.7-14.2-17.3 0-9.6 6.4-17.4 14.2-17.4 7.9 0 14.3 7.8 14.3 17.4 0 9.6-6.4 17.3-14.3 17.3zm0-32.9c-6.8 0-12.4 7-12.4 15.6 0 8.6 5.6 15.5 12.4 15.5 6.9 0 12.5-6.9 12.5-15.5 0-8.6-5.6-15.6-12.5-15.6z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m681.5 204.5h-136.2v-136.2h136.2z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s78",
    d: "m604.1 153h4.4v-49.8h-4.4v-3h7.5v52.8h4.4v3h-11.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s78",
    d: "m630.7 105.1v12.3c0 1.8-0.7 3.4-2 4.6 1.3 1.1 2 2.6 2 4.4v23.6c0 3.3-2.7 6-5.9 6-3.3 0-6-2.7-6-6v-23.6c0-1.8 0.8-3.3 2-4.4-1.2-1.2-2-2.8-2-4.6v-12.3c0-3.2 2.7-6 6-6 3.2 0 5.9 2.6 5.9 6zm-3 12.3v-12.3c0-1.6-1.3-2.9-2.9-2.9-1.7 0-3 1.3-3 2.9v12.3c0 1.6 1.2 3.1 3 3.1 1.7 0 2.9-1.5 2.9-3.1zm0 32.6v-23.6c0-1.6-1.1-3-2.9-3-1.8 0-3 1.3-3 3v23.6c0 1.8 1.3 3 3 3 1.6 0 2.9-1.2 2.9-3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s79",
    d: "m681.5 84.7h-136.2v-16.4h136.2z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m587.9 182.5v5.4c0 1.9-1.5 3.5-3.4 3.5h-4c-1.9 0-3.4-1.6-3.4-3.5v-5.4h1.6v5.4c0 1.1 0.7 2.4 1.9 2.4h3.8c1.2 0 2-1.3 2-2.4v-5.4c0-1.5-0.7-2-1.9-2.9-1.5-1.1-3.1-2.3-4.7-3.4-1.7-1.1-2.3-2.2-2.3-3.7v-4.6c0-1.9 1.5-3.6 3.4-3.6h3.1 0.1c1.9 0.1 3.4 1.7 3.4 3.6v5.4h-1.6v-5.4c0-1.1-0.7-2.4-1.9-2.4h-3.1c-1.1 0-1.9 1.3-1.9 2.4v4.2c0 1.9 0.7 2.3 2 3.2 1.1 0.7 3.6 2.6 4.9 3.4 2 1.4 2 2.8 2 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m602.3 164.4v23.5c0 1.9-1.5 3.5-3.4 3.5h-3.5c-1.9 0-3.5-1.6-3.5-3.5v-23.5h1.6v23.5c0 1.1 0.8 2.4 1.9 2.4h3.5c1.1 0 1.9-1.3 1.9-2.4v-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m617.6 164.4v26.9h-1.3-0.2-1.6l-6.1-25.4v25.4h-1.6v-26.9h1.2 0.4 1.1l6.6 26v-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m632.3 167.9v20c0 1.9-1.6 3.4-3.5 3.4h-6.9v-26.9h6.9c2.3 0 3.5 1.6 3.5 3.5zm-1.6 20v-20c0-1.1-0.8-2.3-1.9-2.3h-5.4v24.6h5.4c1.1 0 1.9-1.2 1.9-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m643.5 182.5h-6l-1.6 8.8h-1.5l5-26.9h2.2l5 26.9h-1.5zm-0.2-1.2l-2.8-15.4-2.8 15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s53",
    d: "m657.7 164.4l-5.2 15v11.9h-1.5v-11.9l-5.2-15h1.5l4.4 12.8 4.5-12.8z"
  })))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m118.1 1028.2q339.8 0 679.6 0 364.4 0 728.9 0c5.9 0 5.9 9.2 0 9.2q-338.9 0-677.7 0-365.4 0-730.8 0c-5.9 0-5.9-9.2 0-9.2z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.c99292302e7d6a3636ad390ce180c7a1.svg";
export { ForwardRef as ReactComponent };